// src/generated/contentful-sdk.ts
import gql from "graphql-tag";
var AccordionAccordionItemsCollectionOrder = /* @__PURE__ */ ((AccordionAccordionItemsCollectionOrder2) => {
  AccordionAccordionItemsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionAccordionItemsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionAccordionItemsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionAccordionItemsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionAccordionItemsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionAccordionItemsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionAccordionItemsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionAccordionItemsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  AccordionAccordionItemsCollectionOrder2["TitleAsc"] = "title_ASC";
  AccordionAccordionItemsCollectionOrder2["TitleDesc"] = "title_DESC";
  return AccordionAccordionItemsCollectionOrder2;
})(AccordionAccordionItemsCollectionOrder || {});
var AccordionItemLinkingCollectionsAccordionCollectionOrder = /* @__PURE__ */ ((AccordionItemLinkingCollectionsAccordionCollectionOrder2) => {
  AccordionItemLinkingCollectionsAccordionCollectionOrder2["IdAsc"] = "id_ASC";
  AccordionItemLinkingCollectionsAccordionCollectionOrder2["IdDesc"] = "id_DESC";
  AccordionItemLinkingCollectionsAccordionCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionItemLinkingCollectionsAccordionCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionItemLinkingCollectionsAccordionCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionItemLinkingCollectionsAccordionCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionItemLinkingCollectionsAccordionCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionItemLinkingCollectionsAccordionCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionItemLinkingCollectionsAccordionCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionItemLinkingCollectionsAccordionCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionItemLinkingCollectionsAccordionCollectionOrder2;
})(AccordionItemLinkingCollectionsAccordionCollectionOrder || {});
var AccordionItemOrder = /* @__PURE__ */ ((AccordionItemOrder2) => {
  AccordionItemOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionItemOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionItemOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionItemOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionItemOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionItemOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionItemOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionItemOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  AccordionItemOrder2["TitleAsc"] = "title_ASC";
  AccordionItemOrder2["TitleDesc"] = "title_DESC";
  return AccordionItemOrder2;
})(AccordionItemOrder || {});
var AccordionOrder = /* @__PURE__ */ ((AccordionOrder2) => {
  AccordionOrder2["IdAsc"] = "id_ASC";
  AccordionOrder2["IdDesc"] = "id_DESC";
  AccordionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AccordionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AccordionOrder2["SysIdAsc"] = "sys_id_ASC";
  AccordionOrder2["SysIdDesc"] = "sys_id_DESC";
  AccordionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AccordionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AccordionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AccordionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return AccordionOrder2;
})(AccordionOrder || {});
var AssetOrder = /* @__PURE__ */ ((AssetOrder2) => {
  AssetOrder2["ContentTypeAsc"] = "contentType_ASC";
  AssetOrder2["ContentTypeDesc"] = "contentType_DESC";
  AssetOrder2["FileNameAsc"] = "fileName_ASC";
  AssetOrder2["FileNameDesc"] = "fileName_DESC";
  AssetOrder2["HeightAsc"] = "height_ASC";
  AssetOrder2["HeightDesc"] = "height_DESC";
  AssetOrder2["SizeAsc"] = "size_ASC";
  AssetOrder2["SizeDesc"] = "size_DESC";
  AssetOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  AssetOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  AssetOrder2["SysIdAsc"] = "sys_id_ASC";
  AssetOrder2["SysIdDesc"] = "sys_id_DESC";
  AssetOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  AssetOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  AssetOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  AssetOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  AssetOrder2["UrlAsc"] = "url_ASC";
  AssetOrder2["UrlDesc"] = "url_DESC";
  AssetOrder2["WidthAsc"] = "width_ASC";
  AssetOrder2["WidthDesc"] = "width_DESC";
  return AssetOrder2;
})(AssetOrder || {});
var BannerLinkingCollectionsHomepageCollectionOrder = /* @__PURE__ */ ((BannerLinkingCollectionsHomepageCollectionOrder2) => {
  BannerLinkingCollectionsHomepageCollectionOrder2["IdAsc"] = "id_ASC";
  BannerLinkingCollectionsHomepageCollectionOrder2["IdDesc"] = "id_DESC";
  BannerLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  BannerLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  BannerLinkingCollectionsHomepageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  BannerLinkingCollectionsHomepageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  BannerLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  BannerLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  BannerLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  BannerLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return BannerLinkingCollectionsHomepageCollectionOrder2;
})(BannerLinkingCollectionsHomepageCollectionOrder || {});
var BannerOrder = /* @__PURE__ */ ((BannerOrder2) => {
  BannerOrder2["DesktopOnlyAsc"] = "desktopOnly_ASC";
  BannerOrder2["DesktopOnlyDesc"] = "desktopOnly_DESC";
  BannerOrder2["DismissableAsc"] = "dismissable_ASC";
  BannerOrder2["DismissableDesc"] = "dismissable_DESC";
  BannerOrder2["EnabledAsc"] = "enabled_ASC";
  BannerOrder2["EnabledDesc"] = "enabled_DESC";
  BannerOrder2["HeadingAsc"] = "heading_ASC";
  BannerOrder2["HeadingDesc"] = "heading_DESC";
  BannerOrder2["IconAsc"] = "icon_ASC";
  BannerOrder2["IconDesc"] = "icon_DESC";
  BannerOrder2["InternalNameAsc"] = "internalName_ASC";
  BannerOrder2["InternalNameDesc"] = "internalName_DESC";
  BannerOrder2["KeyAsc"] = "key_ASC";
  BannerOrder2["KeyDesc"] = "key_DESC";
  BannerOrder2["ShowAgainAsc"] = "showAgain_ASC";
  BannerOrder2["ShowAgainDesc"] = "showAgain_DESC";
  BannerOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  BannerOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  BannerOrder2["SysIdAsc"] = "sys_id_ASC";
  BannerOrder2["SysIdDesc"] = "sys_id_DESC";
  BannerOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  BannerOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  BannerOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  BannerOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return BannerOrder2;
})(BannerOrder || {});
var BenefitsSolutionsListCollectionOrder = /* @__PURE__ */ ((BenefitsSolutionsListCollectionOrder2) => {
  BenefitsSolutionsListCollectionOrder2["HeadingAsc"] = "heading_ASC";
  BenefitsSolutionsListCollectionOrder2["HeadingDesc"] = "heading_DESC";
  BenefitsSolutionsListCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  BenefitsSolutionsListCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  BenefitsSolutionsListCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  BenefitsSolutionsListCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  BenefitsSolutionsListCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  BenefitsSolutionsListCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  BenefitsSolutionsListCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  BenefitsSolutionsListCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return BenefitsSolutionsListCollectionOrder2;
})(BenefitsSolutionsListCollectionOrder || {});
var BenefitsSolutionsOrder = /* @__PURE__ */ ((BenefitsSolutionsOrder2) => {
  BenefitsSolutionsOrder2["BackgroundAsc"] = "background_ASC";
  BenefitsSolutionsOrder2["BackgroundDesc"] = "background_DESC";
  BenefitsSolutionsOrder2["HeadingAsc"] = "heading_ASC";
  BenefitsSolutionsOrder2["HeadingDesc"] = "heading_DESC";
  BenefitsSolutionsOrder2["IdAsc"] = "id_ASC";
  BenefitsSolutionsOrder2["IdDesc"] = "id_DESC";
  BenefitsSolutionsOrder2["SubHeadingAsc"] = "subHeading_ASC";
  BenefitsSolutionsOrder2["SubHeadingDesc"] = "subHeading_DESC";
  BenefitsSolutionsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  BenefitsSolutionsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  BenefitsSolutionsOrder2["SysIdAsc"] = "sys_id_ASC";
  BenefitsSolutionsOrder2["SysIdDesc"] = "sys_id_DESC";
  BenefitsSolutionsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  BenefitsSolutionsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  BenefitsSolutionsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  BenefitsSolutionsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  BenefitsSolutionsOrder2["VariantAsc"] = "variant_ASC";
  BenefitsSolutionsOrder2["VariantDesc"] = "variant_DESC";
  return BenefitsSolutionsOrder2;
})(BenefitsSolutionsOrder || {});
var BlogPostLinkingCollectionsBlogPostCollectionOrder = /* @__PURE__ */ ((BlogPostLinkingCollectionsBlogPostCollectionOrder2) => {
  BlogPostLinkingCollectionsBlogPostCollectionOrder2["CreatedAtAsc"] = "createdAt_ASC";
  BlogPostLinkingCollectionsBlogPostCollectionOrder2["CreatedAtDesc"] = "createdAt_DESC";
  BlogPostLinkingCollectionsBlogPostCollectionOrder2["SlugAsc"] = "slug_ASC";
  BlogPostLinkingCollectionsBlogPostCollectionOrder2["SlugDesc"] = "slug_DESC";
  BlogPostLinkingCollectionsBlogPostCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  BlogPostLinkingCollectionsBlogPostCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  BlogPostLinkingCollectionsBlogPostCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  BlogPostLinkingCollectionsBlogPostCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  BlogPostLinkingCollectionsBlogPostCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  BlogPostLinkingCollectionsBlogPostCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  BlogPostLinkingCollectionsBlogPostCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  BlogPostLinkingCollectionsBlogPostCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  BlogPostLinkingCollectionsBlogPostCollectionOrder2["TitleAsc"] = "title_ASC";
  BlogPostLinkingCollectionsBlogPostCollectionOrder2["TitleDesc"] = "title_DESC";
  BlogPostLinkingCollectionsBlogPostCollectionOrder2["UpdatedAtAsc"] = "updatedAt_ASC";
  BlogPostLinkingCollectionsBlogPostCollectionOrder2["UpdatedAtDesc"] = "updatedAt_DESC";
  return BlogPostLinkingCollectionsBlogPostCollectionOrder2;
})(BlogPostLinkingCollectionsBlogPostCollectionOrder || {});
var BlogPostOrder = /* @__PURE__ */ ((BlogPostOrder2) => {
  BlogPostOrder2["CreatedAtAsc"] = "createdAt_ASC";
  BlogPostOrder2["CreatedAtDesc"] = "createdAt_DESC";
  BlogPostOrder2["SlugAsc"] = "slug_ASC";
  BlogPostOrder2["SlugDesc"] = "slug_DESC";
  BlogPostOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  BlogPostOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  BlogPostOrder2["SysIdAsc"] = "sys_id_ASC";
  BlogPostOrder2["SysIdDesc"] = "sys_id_DESC";
  BlogPostOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  BlogPostOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  BlogPostOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  BlogPostOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  BlogPostOrder2["TitleAsc"] = "title_ASC";
  BlogPostOrder2["TitleDesc"] = "title_DESC";
  BlogPostOrder2["UpdatedAtAsc"] = "updatedAt_ASC";
  BlogPostOrder2["UpdatedAtDesc"] = "updatedAt_DESC";
  return BlogPostOrder2;
})(BlogPostOrder || {});
var BlogPostRelatedPostsCollectionOrder = /* @__PURE__ */ ((BlogPostRelatedPostsCollectionOrder2) => {
  BlogPostRelatedPostsCollectionOrder2["CreatedAtAsc"] = "createdAt_ASC";
  BlogPostRelatedPostsCollectionOrder2["CreatedAtDesc"] = "createdAt_DESC";
  BlogPostRelatedPostsCollectionOrder2["SlugAsc"] = "slug_ASC";
  BlogPostRelatedPostsCollectionOrder2["SlugDesc"] = "slug_DESC";
  BlogPostRelatedPostsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  BlogPostRelatedPostsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  BlogPostRelatedPostsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  BlogPostRelatedPostsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  BlogPostRelatedPostsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  BlogPostRelatedPostsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  BlogPostRelatedPostsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  BlogPostRelatedPostsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  BlogPostRelatedPostsCollectionOrder2["TitleAsc"] = "title_ASC";
  BlogPostRelatedPostsCollectionOrder2["TitleDesc"] = "title_DESC";
  BlogPostRelatedPostsCollectionOrder2["UpdatedAtAsc"] = "updatedAt_ASC";
  BlogPostRelatedPostsCollectionOrder2["UpdatedAtDesc"] = "updatedAt_DESC";
  return BlogPostRelatedPostsCollectionOrder2;
})(BlogPostRelatedPostsCollectionOrder || {});
var BlogTableCellReferenceOrder = /* @__PURE__ */ ((BlogTableCellReferenceOrder2) => {
  BlogTableCellReferenceOrder2["CoordinatesAsc"] = "coordinates_ASC";
  BlogTableCellReferenceOrder2["CoordinatesDesc"] = "coordinates_DESC";
  BlogTableCellReferenceOrder2["KeyAsc"] = "key_ASC";
  BlogTableCellReferenceOrder2["KeyDesc"] = "key_DESC";
  BlogTableCellReferenceOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  BlogTableCellReferenceOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  BlogTableCellReferenceOrder2["SysIdAsc"] = "sys_id_ASC";
  BlogTableCellReferenceOrder2["SysIdDesc"] = "sys_id_DESC";
  BlogTableCellReferenceOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  BlogTableCellReferenceOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  BlogTableCellReferenceOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  BlogTableCellReferenceOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  BlogTableCellReferenceOrder2["TitleAsc"] = "title_ASC";
  BlogTableCellReferenceOrder2["TitleDesc"] = "title_DESC";
  return BlogTableCellReferenceOrder2;
})(BlogTableCellReferenceOrder || {});
var CallOutBoxOrder = /* @__PURE__ */ ((CallOutBoxOrder2) => {
  CallOutBoxOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CallOutBoxOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CallOutBoxOrder2["SysIdAsc"] = "sys_id_ASC";
  CallOutBoxOrder2["SysIdDesc"] = "sys_id_DESC";
  CallOutBoxOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CallOutBoxOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CallOutBoxOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CallOutBoxOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  CallOutBoxOrder2["TitleAsc"] = "title_ASC";
  CallOutBoxOrder2["TitleDesc"] = "title_DESC";
  return CallOutBoxOrder2;
})(CallOutBoxOrder || {});
var CardLinkingCollectionsCardListCollectionOrder = /* @__PURE__ */ ((CardLinkingCollectionsCardListCollectionOrder2) => {
  CardLinkingCollectionsCardListCollectionOrder2["HeadingAsc"] = "heading_ASC";
  CardLinkingCollectionsCardListCollectionOrder2["HeadingDesc"] = "heading_DESC";
  CardLinkingCollectionsCardListCollectionOrder2["IdAsc"] = "id_ASC";
  CardLinkingCollectionsCardListCollectionOrder2["IdDesc"] = "id_DESC";
  CardLinkingCollectionsCardListCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CardLinkingCollectionsCardListCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CardLinkingCollectionsCardListCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CardLinkingCollectionsCardListCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CardLinkingCollectionsCardListCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CardLinkingCollectionsCardListCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CardLinkingCollectionsCardListCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CardLinkingCollectionsCardListCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CardLinkingCollectionsCardListCollectionOrder2;
})(CardLinkingCollectionsCardListCollectionOrder || {});
var CardListCardsCollectionOrder = /* @__PURE__ */ ((CardListCardsCollectionOrder2) => {
  CardListCardsCollectionOrder2["CtaLabelAsc"] = "ctaLabel_ASC";
  CardListCardsCollectionOrder2["CtaLabelDesc"] = "ctaLabel_DESC";
  CardListCardsCollectionOrder2["HeadingAsc"] = "heading_ASC";
  CardListCardsCollectionOrder2["HeadingDesc"] = "heading_DESC";
  CardListCardsCollectionOrder2["LinkAsc"] = "link_ASC";
  CardListCardsCollectionOrder2["LinkDesc"] = "link_DESC";
  CardListCardsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CardListCardsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CardListCardsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CardListCardsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CardListCardsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CardListCardsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CardListCardsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CardListCardsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CardListCardsCollectionOrder2;
})(CardListCardsCollectionOrder || {});
var CardListLinkingCollectionsHomepageCollectionOrder = /* @__PURE__ */ ((CardListLinkingCollectionsHomepageCollectionOrder2) => {
  CardListLinkingCollectionsHomepageCollectionOrder2["IdAsc"] = "id_ASC";
  CardListLinkingCollectionsHomepageCollectionOrder2["IdDesc"] = "id_DESC";
  CardListLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CardListLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CardListLinkingCollectionsHomepageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CardListLinkingCollectionsHomepageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CardListLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CardListLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CardListLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CardListLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CardListLinkingCollectionsHomepageCollectionOrder2;
})(CardListLinkingCollectionsHomepageCollectionOrder || {});
var CardListOrder = /* @__PURE__ */ ((CardListOrder2) => {
  CardListOrder2["HeadingAsc"] = "heading_ASC";
  CardListOrder2["HeadingDesc"] = "heading_DESC";
  CardListOrder2["IdAsc"] = "id_ASC";
  CardListOrder2["IdDesc"] = "id_DESC";
  CardListOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CardListOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CardListOrder2["SysIdAsc"] = "sys_id_ASC";
  CardListOrder2["SysIdDesc"] = "sys_id_DESC";
  CardListOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CardListOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CardListOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CardListOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CardListOrder2;
})(CardListOrder || {});
var CardOrder = /* @__PURE__ */ ((CardOrder2) => {
  CardOrder2["CtaLabelAsc"] = "ctaLabel_ASC";
  CardOrder2["CtaLabelDesc"] = "ctaLabel_DESC";
  CardOrder2["HeadingAsc"] = "heading_ASC";
  CardOrder2["HeadingDesc"] = "heading_DESC";
  CardOrder2["LinkAsc"] = "link_ASC";
  CardOrder2["LinkDesc"] = "link_DESC";
  CardOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CardOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CardOrder2["SysIdAsc"] = "sys_id_ASC";
  CardOrder2["SysIdDesc"] = "sys_id_DESC";
  CardOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CardOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CardOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CardOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CardOrder2;
})(CardOrder || {});
var CategoryClosestAlternativesCollectionOrder = /* @__PURE__ */ ((CategoryClosestAlternativesCollectionOrder2) => {
  CategoryClosestAlternativesCollectionOrder2["CategoryIdAsc"] = "categoryId_ASC";
  CategoryClosestAlternativesCollectionOrder2["CategoryIdDesc"] = "categoryId_DESC";
  CategoryClosestAlternativesCollectionOrder2["LabelAsc"] = "label_ASC";
  CategoryClosestAlternativesCollectionOrder2["LabelDesc"] = "label_DESC";
  CategoryClosestAlternativesCollectionOrder2["LifecycleStageAsc"] = "lifecycleStage_ASC";
  CategoryClosestAlternativesCollectionOrder2["LifecycleStageDesc"] = "lifecycleStage_DESC";
  CategoryClosestAlternativesCollectionOrder2["LinkOrUrlAsc"] = "linkOrUrl_ASC";
  CategoryClosestAlternativesCollectionOrder2["LinkOrUrlDesc"] = "linkOrUrl_DESC";
  CategoryClosestAlternativesCollectionOrder2["SlugAsc"] = "slug_ASC";
  CategoryClosestAlternativesCollectionOrder2["SlugDesc"] = "slug_DESC";
  CategoryClosestAlternativesCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CategoryClosestAlternativesCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CategoryClosestAlternativesCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CategoryClosestAlternativesCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CategoryClosestAlternativesCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CategoryClosestAlternativesCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CategoryClosestAlternativesCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CategoryClosestAlternativesCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CategoryClosestAlternativesCollectionOrder2;
})(CategoryClosestAlternativesCollectionOrder || {});
var CategoryHeroLinkingCollectionsProductCategoryCollectionOrder = /* @__PURE__ */ ((CategoryHeroLinkingCollectionsProductCategoryCollectionOrder2) => {
  CategoryHeroLinkingCollectionsProductCategoryCollectionOrder2["NameAsc"] = "name_ASC";
  CategoryHeroLinkingCollectionsProductCategoryCollectionOrder2["NameDesc"] = "name_DESC";
  CategoryHeroLinkingCollectionsProductCategoryCollectionOrder2["SlugAsc"] = "slug_ASC";
  CategoryHeroLinkingCollectionsProductCategoryCollectionOrder2["SlugDesc"] = "slug_DESC";
  CategoryHeroLinkingCollectionsProductCategoryCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CategoryHeroLinkingCollectionsProductCategoryCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CategoryHeroLinkingCollectionsProductCategoryCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CategoryHeroLinkingCollectionsProductCategoryCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CategoryHeroLinkingCollectionsProductCategoryCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CategoryHeroLinkingCollectionsProductCategoryCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CategoryHeroLinkingCollectionsProductCategoryCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CategoryHeroLinkingCollectionsProductCategoryCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CategoryHeroLinkingCollectionsProductCategoryCollectionOrder2;
})(CategoryHeroLinkingCollectionsProductCategoryCollectionOrder || {});
var CategoryHeroOrder = /* @__PURE__ */ ((CategoryHeroOrder2) => {
  CategoryHeroOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CategoryHeroOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CategoryHeroOrder2["SysIdAsc"] = "sys_id_ASC";
  CategoryHeroOrder2["SysIdDesc"] = "sys_id_DESC";
  CategoryHeroOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CategoryHeroOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CategoryHeroOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CategoryHeroOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  CategoryHeroOrder2["TitleAsc"] = "title_ASC";
  CategoryHeroOrder2["TitleDesc"] = "title_DESC";
  return CategoryHeroOrder2;
})(CategoryHeroOrder || {});
var CategoryLandingPageHeroListCollectionOrder = /* @__PURE__ */ ((CategoryLandingPageHeroListCollectionOrder2) => {
  CategoryLandingPageHeroListCollectionOrder2["HeadingAsc"] = "heading_ASC";
  CategoryLandingPageHeroListCollectionOrder2["HeadingDesc"] = "heading_DESC";
  CategoryLandingPageHeroListCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CategoryLandingPageHeroListCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CategoryLandingPageHeroListCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CategoryLandingPageHeroListCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CategoryLandingPageHeroListCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CategoryLandingPageHeroListCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CategoryLandingPageHeroListCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CategoryLandingPageHeroListCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CategoryLandingPageHeroListCollectionOrder2;
})(CategoryLandingPageHeroListCollectionOrder || {});
var CategoryLandingPageHeroOrder = /* @__PURE__ */ ((CategoryLandingPageHeroOrder2) => {
  CategoryLandingPageHeroOrder2["BannerHeadingAsc"] = "bannerHeading_ASC";
  CategoryLandingPageHeroOrder2["BannerHeadingDesc"] = "bannerHeading_DESC";
  CategoryLandingPageHeroOrder2["BannerRatingAsc"] = "bannerRating_ASC";
  CategoryLandingPageHeroOrder2["BannerRatingDesc"] = "bannerRating_DESC";
  CategoryLandingPageHeroOrder2["BannerSubHeadingAsc"] = "bannerSubHeading_ASC";
  CategoryLandingPageHeroOrder2["BannerSubHeadingDesc"] = "bannerSubHeading_DESC";
  CategoryLandingPageHeroOrder2["HeadingAsc"] = "heading_ASC";
  CategoryLandingPageHeroOrder2["HeadingDesc"] = "heading_DESC";
  CategoryLandingPageHeroOrder2["IdAsc"] = "id_ASC";
  CategoryLandingPageHeroOrder2["IdDesc"] = "id_DESC";
  CategoryLandingPageHeroOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CategoryLandingPageHeroOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CategoryLandingPageHeroOrder2["SysIdAsc"] = "sys_id_ASC";
  CategoryLandingPageHeroOrder2["SysIdDesc"] = "sys_id_DESC";
  CategoryLandingPageHeroOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CategoryLandingPageHeroOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CategoryLandingPageHeroOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CategoryLandingPageHeroOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CategoryLandingPageHeroOrder2;
})(CategoryLandingPageHeroOrder || {});
var CategoryLandingPageOrder = /* @__PURE__ */ ((CategoryLandingPageOrder2) => {
  CategoryLandingPageOrder2["CtaTextAsc"] = "ctaText_ASC";
  CategoryLandingPageOrder2["CtaTextDesc"] = "ctaText_DESC";
  CategoryLandingPageOrder2["LandingPageNameAsc"] = "landingPageName_ASC";
  CategoryLandingPageOrder2["LandingPageNameDesc"] = "landingPageName_DESC";
  CategoryLandingPageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CategoryLandingPageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CategoryLandingPageOrder2["SysIdAsc"] = "sys_id_ASC";
  CategoryLandingPageOrder2["SysIdDesc"] = "sys_id_DESC";
  CategoryLandingPageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CategoryLandingPageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CategoryLandingPageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CategoryLandingPageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CategoryLandingPageOrder2;
})(CategoryLandingPageOrder || {});
var CategoryLinkingCollectionsBlogPostCollectionOrder = /* @__PURE__ */ ((CategoryLinkingCollectionsBlogPostCollectionOrder2) => {
  CategoryLinkingCollectionsBlogPostCollectionOrder2["CreatedAtAsc"] = "createdAt_ASC";
  CategoryLinkingCollectionsBlogPostCollectionOrder2["CreatedAtDesc"] = "createdAt_DESC";
  CategoryLinkingCollectionsBlogPostCollectionOrder2["SlugAsc"] = "slug_ASC";
  CategoryLinkingCollectionsBlogPostCollectionOrder2["SlugDesc"] = "slug_DESC";
  CategoryLinkingCollectionsBlogPostCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CategoryLinkingCollectionsBlogPostCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CategoryLinkingCollectionsBlogPostCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CategoryLinkingCollectionsBlogPostCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CategoryLinkingCollectionsBlogPostCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CategoryLinkingCollectionsBlogPostCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CategoryLinkingCollectionsBlogPostCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CategoryLinkingCollectionsBlogPostCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  CategoryLinkingCollectionsBlogPostCollectionOrder2["TitleAsc"] = "title_ASC";
  CategoryLinkingCollectionsBlogPostCollectionOrder2["TitleDesc"] = "title_DESC";
  CategoryLinkingCollectionsBlogPostCollectionOrder2["UpdatedAtAsc"] = "updatedAt_ASC";
  CategoryLinkingCollectionsBlogPostCollectionOrder2["UpdatedAtDesc"] = "updatedAt_DESC";
  return CategoryLinkingCollectionsBlogPostCollectionOrder2;
})(CategoryLinkingCollectionsBlogPostCollectionOrder || {});
var CategoryLinkingCollectionsCategoryCollectionOrder = /* @__PURE__ */ ((CategoryLinkingCollectionsCategoryCollectionOrder2) => {
  CategoryLinkingCollectionsCategoryCollectionOrder2["CategoryIdAsc"] = "categoryId_ASC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["CategoryIdDesc"] = "categoryId_DESC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["LabelAsc"] = "label_ASC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["LabelDesc"] = "label_DESC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["LifecycleStageAsc"] = "lifecycleStage_ASC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["LifecycleStageDesc"] = "lifecycleStage_DESC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["LinkOrUrlAsc"] = "linkOrUrl_ASC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["LinkOrUrlDesc"] = "linkOrUrl_DESC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["SlugAsc"] = "slug_ASC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["SlugDesc"] = "slug_DESC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CategoryLinkingCollectionsCategoryCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CategoryLinkingCollectionsCategoryCollectionOrder2;
})(CategoryLinkingCollectionsCategoryCollectionOrder || {});
var CategoryLinkingCollectionsCategoryLandingPageCollectionOrder = /* @__PURE__ */ ((CategoryLinkingCollectionsCategoryLandingPageCollectionOrder2) => {
  CategoryLinkingCollectionsCategoryLandingPageCollectionOrder2["CtaTextAsc"] = "ctaText_ASC";
  CategoryLinkingCollectionsCategoryLandingPageCollectionOrder2["CtaTextDesc"] = "ctaText_DESC";
  CategoryLinkingCollectionsCategoryLandingPageCollectionOrder2["LandingPageNameAsc"] = "landingPageName_ASC";
  CategoryLinkingCollectionsCategoryLandingPageCollectionOrder2["LandingPageNameDesc"] = "landingPageName_DESC";
  CategoryLinkingCollectionsCategoryLandingPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CategoryLinkingCollectionsCategoryLandingPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CategoryLinkingCollectionsCategoryLandingPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CategoryLinkingCollectionsCategoryLandingPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CategoryLinkingCollectionsCategoryLandingPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CategoryLinkingCollectionsCategoryLandingPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CategoryLinkingCollectionsCategoryLandingPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CategoryLinkingCollectionsCategoryLandingPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CategoryLinkingCollectionsCategoryLandingPageCollectionOrder2;
})(CategoryLinkingCollectionsCategoryLandingPageCollectionOrder || {});
var CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder = /* @__PURE__ */ ((CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder2) => {
  CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["BlurbHeadingAsc"] = "blurbHeading_ASC";
  CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["BlurbHeadingDesc"] = "blurbHeading_DESC";
  CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["PageHeadingH1Asc"] = "pageHeadingH1_ASC";
  CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["PageHeadingH1Desc"] = "pageHeadingH1_DESC";
  CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["PageNameAsc"] = "pageName_ASC";
  CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["PageNameDesc"] = "pageName_DESC";
  CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder2;
})(CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder || {});
var CategoryLinkingCollectionsPopularSearchesCollectionOrder = /* @__PURE__ */ ((CategoryLinkingCollectionsPopularSearchesCollectionOrder2) => {
  CategoryLinkingCollectionsPopularSearchesCollectionOrder2["HeadingAsc"] = "heading_ASC";
  CategoryLinkingCollectionsPopularSearchesCollectionOrder2["HeadingDesc"] = "heading_DESC";
  CategoryLinkingCollectionsPopularSearchesCollectionOrder2["IdAsc"] = "id_ASC";
  CategoryLinkingCollectionsPopularSearchesCollectionOrder2["IdDesc"] = "id_DESC";
  CategoryLinkingCollectionsPopularSearchesCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CategoryLinkingCollectionsPopularSearchesCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CategoryLinkingCollectionsPopularSearchesCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CategoryLinkingCollectionsPopularSearchesCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CategoryLinkingCollectionsPopularSearchesCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CategoryLinkingCollectionsPopularSearchesCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CategoryLinkingCollectionsPopularSearchesCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CategoryLinkingCollectionsPopularSearchesCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CategoryLinkingCollectionsPopularSearchesCollectionOrder2;
})(CategoryLinkingCollectionsPopularSearchesCollectionOrder || {});
var CategoryLinkingCollectionsSearchLandingPageCollectionOrder = /* @__PURE__ */ ((CategoryLinkingCollectionsSearchLandingPageCollectionOrder2) => {
  CategoryLinkingCollectionsSearchLandingPageCollectionOrder2["BlurbHeadingAsc"] = "blurbHeading_ASC";
  CategoryLinkingCollectionsSearchLandingPageCollectionOrder2["BlurbHeadingDesc"] = "blurbHeading_DESC";
  CategoryLinkingCollectionsSearchLandingPageCollectionOrder2["PageHeadingH1Asc"] = "pageHeadingH1_ASC";
  CategoryLinkingCollectionsSearchLandingPageCollectionOrder2["PageHeadingH1Desc"] = "pageHeadingH1_DESC";
  CategoryLinkingCollectionsSearchLandingPageCollectionOrder2["PageNameAsc"] = "pageName_ASC";
  CategoryLinkingCollectionsSearchLandingPageCollectionOrder2["PageNameDesc"] = "pageName_DESC";
  CategoryLinkingCollectionsSearchLandingPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CategoryLinkingCollectionsSearchLandingPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CategoryLinkingCollectionsSearchLandingPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CategoryLinkingCollectionsSearchLandingPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CategoryLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CategoryLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CategoryLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CategoryLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CategoryLinkingCollectionsSearchLandingPageCollectionOrder2;
})(CategoryLinkingCollectionsSearchLandingPageCollectionOrder || {});
var CategoryOrder = /* @__PURE__ */ ((CategoryOrder2) => {
  CategoryOrder2["CategoryIdAsc"] = "categoryId_ASC";
  CategoryOrder2["CategoryIdDesc"] = "categoryId_DESC";
  CategoryOrder2["LabelAsc"] = "label_ASC";
  CategoryOrder2["LabelDesc"] = "label_DESC";
  CategoryOrder2["LifecycleStageAsc"] = "lifecycleStage_ASC";
  CategoryOrder2["LifecycleStageDesc"] = "lifecycleStage_DESC";
  CategoryOrder2["LinkOrUrlAsc"] = "linkOrUrl_ASC";
  CategoryOrder2["LinkOrUrlDesc"] = "linkOrUrl_DESC";
  CategoryOrder2["SlugAsc"] = "slug_ASC";
  CategoryOrder2["SlugDesc"] = "slug_DESC";
  CategoryOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CategoryOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CategoryOrder2["SysIdAsc"] = "sys_id_ASC";
  CategoryOrder2["SysIdDesc"] = "sys_id_DESC";
  CategoryOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CategoryOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CategoryOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CategoryOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CategoryOrder2;
})(CategoryOrder || {});
var CategorySubCategoriesCollectionOrder = /* @__PURE__ */ ((CategorySubCategoriesCollectionOrder2) => {
  CategorySubCategoriesCollectionOrder2["CategoryIdAsc"] = "categoryId_ASC";
  CategorySubCategoriesCollectionOrder2["CategoryIdDesc"] = "categoryId_DESC";
  CategorySubCategoriesCollectionOrder2["LabelAsc"] = "label_ASC";
  CategorySubCategoriesCollectionOrder2["LabelDesc"] = "label_DESC";
  CategorySubCategoriesCollectionOrder2["LifecycleStageAsc"] = "lifecycleStage_ASC";
  CategorySubCategoriesCollectionOrder2["LifecycleStageDesc"] = "lifecycleStage_DESC";
  CategorySubCategoriesCollectionOrder2["LinkOrUrlAsc"] = "linkOrUrl_ASC";
  CategorySubCategoriesCollectionOrder2["LinkOrUrlDesc"] = "linkOrUrl_DESC";
  CategorySubCategoriesCollectionOrder2["SlugAsc"] = "slug_ASC";
  CategorySubCategoriesCollectionOrder2["SlugDesc"] = "slug_DESC";
  CategorySubCategoriesCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  CategorySubCategoriesCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  CategorySubCategoriesCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  CategorySubCategoriesCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  CategorySubCategoriesCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  CategorySubCategoriesCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  CategorySubCategoriesCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  CategorySubCategoriesCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return CategorySubCategoriesCollectionOrder2;
})(CategorySubCategoriesCollectionOrder || {});
var ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder = /* @__PURE__ */ ((ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder2) => {
  ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder2["BlurbHeadingAsc"] = "blurbHeading_ASC";
  ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder2["BlurbHeadingDesc"] = "blurbHeading_DESC";
  ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder2["PageHeadingH1Asc"] = "pageHeadingH1_ASC";
  ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder2["PageHeadingH1Desc"] = "pageHeadingH1_DESC";
  ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder2["PageNameAsc"] = "pageName_ASC";
  ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder2["PageNameDesc"] = "pageName_DESC";
  ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder2;
})(ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder || {});
var ContentTypeLocationOrder = /* @__PURE__ */ ((ContentTypeLocationOrder2) => {
  ContentTypeLocationOrder2["LocationAsc"] = "location_ASC";
  ContentTypeLocationOrder2["LocationDesc"] = "location_DESC";
  ContentTypeLocationOrder2["SlugAsc"] = "slug_ASC";
  ContentTypeLocationOrder2["SlugDesc"] = "slug_DESC";
  ContentTypeLocationOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ContentTypeLocationOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ContentTypeLocationOrder2["SysIdAsc"] = "sys_id_ASC";
  ContentTypeLocationOrder2["SysIdDesc"] = "sys_id_DESC";
  ContentTypeLocationOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ContentTypeLocationOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ContentTypeLocationOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ContentTypeLocationOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ContentTypeLocationOrder2;
})(ContentTypeLocationOrder || {});
var DefaultInterlinksInterlinksCollectionOrder = /* @__PURE__ */ ((DefaultInterlinksInterlinksCollectionOrder2) => {
  DefaultInterlinksInterlinksCollectionOrder2["HeadingAsc"] = "heading_ASC";
  DefaultInterlinksInterlinksCollectionOrder2["HeadingDesc"] = "heading_DESC";
  DefaultInterlinksInterlinksCollectionOrder2["IdAsc"] = "id_ASC";
  DefaultInterlinksInterlinksCollectionOrder2["IdDesc"] = "id_DESC";
  DefaultInterlinksInterlinksCollectionOrder2["KeyAsc"] = "key_ASC";
  DefaultInterlinksInterlinksCollectionOrder2["KeyDesc"] = "key_DESC";
  DefaultInterlinksInterlinksCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  DefaultInterlinksInterlinksCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  DefaultInterlinksInterlinksCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  DefaultInterlinksInterlinksCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  DefaultInterlinksInterlinksCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  DefaultInterlinksInterlinksCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  DefaultInterlinksInterlinksCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  DefaultInterlinksInterlinksCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return DefaultInterlinksInterlinksCollectionOrder2;
})(DefaultInterlinksInterlinksCollectionOrder || {});
var DefaultInterlinksOrder = /* @__PURE__ */ ((DefaultInterlinksOrder2) => {
  DefaultInterlinksOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  DefaultInterlinksOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  DefaultInterlinksOrder2["SysIdAsc"] = "sys_id_ASC";
  DefaultInterlinksOrder2["SysIdDesc"] = "sys_id_DESC";
  DefaultInterlinksOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  DefaultInterlinksOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  DefaultInterlinksOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  DefaultInterlinksOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return DefaultInterlinksOrder2;
})(DefaultInterlinksOrder || {});
var DefaultSearchLandingPageFaqsCollectionOrder = /* @__PURE__ */ ((DefaultSearchLandingPageFaqsCollectionOrder2) => {
  DefaultSearchLandingPageFaqsCollectionOrder2["QuestionAsc"] = "question_ASC";
  DefaultSearchLandingPageFaqsCollectionOrder2["QuestionDesc"] = "question_DESC";
  DefaultSearchLandingPageFaqsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  DefaultSearchLandingPageFaqsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  DefaultSearchLandingPageFaqsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  DefaultSearchLandingPageFaqsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  DefaultSearchLandingPageFaqsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  DefaultSearchLandingPageFaqsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  DefaultSearchLandingPageFaqsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  DefaultSearchLandingPageFaqsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return DefaultSearchLandingPageFaqsCollectionOrder2;
})(DefaultSearchLandingPageFaqsCollectionOrder || {});
var DefaultSearchLandingPageInterlinksCollectionOrder = /* @__PURE__ */ ((DefaultSearchLandingPageInterlinksCollectionOrder2) => {
  DefaultSearchLandingPageInterlinksCollectionOrder2["HeadingAsc"] = "heading_ASC";
  DefaultSearchLandingPageInterlinksCollectionOrder2["HeadingDesc"] = "heading_DESC";
  DefaultSearchLandingPageInterlinksCollectionOrder2["IdAsc"] = "id_ASC";
  DefaultSearchLandingPageInterlinksCollectionOrder2["IdDesc"] = "id_DESC";
  DefaultSearchLandingPageInterlinksCollectionOrder2["KeyAsc"] = "key_ASC";
  DefaultSearchLandingPageInterlinksCollectionOrder2["KeyDesc"] = "key_DESC";
  DefaultSearchLandingPageInterlinksCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  DefaultSearchLandingPageInterlinksCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  DefaultSearchLandingPageInterlinksCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  DefaultSearchLandingPageInterlinksCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  DefaultSearchLandingPageInterlinksCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  DefaultSearchLandingPageInterlinksCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  DefaultSearchLandingPageInterlinksCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  DefaultSearchLandingPageInterlinksCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return DefaultSearchLandingPageInterlinksCollectionOrder2;
})(DefaultSearchLandingPageInterlinksCollectionOrder || {});
var DefaultSearchLandingPageOrder = /* @__PURE__ */ ((DefaultSearchLandingPageOrder2) => {
  DefaultSearchLandingPageOrder2["BlurbHeadingAsc"] = "blurbHeading_ASC";
  DefaultSearchLandingPageOrder2["BlurbHeadingDesc"] = "blurbHeading_DESC";
  DefaultSearchLandingPageOrder2["PageHeadingH1Asc"] = "pageHeadingH1_ASC";
  DefaultSearchLandingPageOrder2["PageHeadingH1Desc"] = "pageHeadingH1_DESC";
  DefaultSearchLandingPageOrder2["PageNameAsc"] = "pageName_ASC";
  DefaultSearchLandingPageOrder2["PageNameDesc"] = "pageName_DESC";
  DefaultSearchLandingPageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  DefaultSearchLandingPageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  DefaultSearchLandingPageOrder2["SysIdAsc"] = "sys_id_ASC";
  DefaultSearchLandingPageOrder2["SysIdDesc"] = "sys_id_DESC";
  DefaultSearchLandingPageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  DefaultSearchLandingPageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  DefaultSearchLandingPageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  DefaultSearchLandingPageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return DefaultSearchLandingPageOrder2;
})(DefaultSearchLandingPageOrder || {});
var EntryOrder = /* @__PURE__ */ ((EntryOrder2) => {
  EntryOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  EntryOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  EntryOrder2["SysIdAsc"] = "sys_id_ASC";
  EntryOrder2["SysIdDesc"] = "sys_id_DESC";
  EntryOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  EntryOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  EntryOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  EntryOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return EntryOrder2;
})(EntryOrder || {});
var HeroImageOrder = /* @__PURE__ */ ((HeroImageOrder2) => {
  HeroImageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroImageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroImageOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroImageOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroImageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroImageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroImageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroImageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HeroImageOrder2;
})(HeroImageOrder || {});
var HeroLinkingCollectionsHomepageCollectionOrder = /* @__PURE__ */ ((HeroLinkingCollectionsHomepageCollectionOrder2) => {
  HeroLinkingCollectionsHomepageCollectionOrder2["IdAsc"] = "id_ASC";
  HeroLinkingCollectionsHomepageCollectionOrder2["IdDesc"] = "id_DESC";
  HeroLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroLinkingCollectionsHomepageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroLinkingCollectionsHomepageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HeroLinkingCollectionsHomepageCollectionOrder2;
})(HeroLinkingCollectionsHomepageCollectionOrder || {});
var HeroLinkingCollectionsShopCollectionOrder = /* @__PURE__ */ ((HeroLinkingCollectionsShopCollectionOrder2) => {
  HeroLinkingCollectionsShopCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroLinkingCollectionsShopCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroLinkingCollectionsShopCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroLinkingCollectionsShopCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroLinkingCollectionsShopCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroLinkingCollectionsShopCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroLinkingCollectionsShopCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroLinkingCollectionsShopCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  HeroLinkingCollectionsShopCollectionOrder2["VersionAsc"] = "version_ASC";
  HeroLinkingCollectionsShopCollectionOrder2["VersionDesc"] = "version_DESC";
  return HeroLinkingCollectionsShopCollectionOrder2;
})(HeroLinkingCollectionsShopCollectionOrder || {});
var HeroOrder = /* @__PURE__ */ ((HeroOrder2) => {
  HeroOrder2["SubtitleAsc"] = "subtitle_ASC";
  HeroOrder2["SubtitleDesc"] = "subtitle_DESC";
  HeroOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HeroOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HeroOrder2["SysIdAsc"] = "sys_id_ASC";
  HeroOrder2["SysIdDesc"] = "sys_id_DESC";
  HeroOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HeroOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HeroOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HeroOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  HeroOrder2["ThemeAsc"] = "theme_ASC";
  HeroOrder2["ThemeDesc"] = "theme_DESC";
  HeroOrder2["TitleAsc"] = "title_ASC";
  HeroOrder2["TitleDesc"] = "title_DESC";
  return HeroOrder2;
})(HeroOrder || {});
var HomepageBannersCollectionOrder = /* @__PURE__ */ ((HomepageBannersCollectionOrder2) => {
  HomepageBannersCollectionOrder2["DesktopOnlyAsc"] = "desktopOnly_ASC";
  HomepageBannersCollectionOrder2["DesktopOnlyDesc"] = "desktopOnly_DESC";
  HomepageBannersCollectionOrder2["DismissableAsc"] = "dismissable_ASC";
  HomepageBannersCollectionOrder2["DismissableDesc"] = "dismissable_DESC";
  HomepageBannersCollectionOrder2["EnabledAsc"] = "enabled_ASC";
  HomepageBannersCollectionOrder2["EnabledDesc"] = "enabled_DESC";
  HomepageBannersCollectionOrder2["HeadingAsc"] = "heading_ASC";
  HomepageBannersCollectionOrder2["HeadingDesc"] = "heading_DESC";
  HomepageBannersCollectionOrder2["IconAsc"] = "icon_ASC";
  HomepageBannersCollectionOrder2["IconDesc"] = "icon_DESC";
  HomepageBannersCollectionOrder2["InternalNameAsc"] = "internalName_ASC";
  HomepageBannersCollectionOrder2["InternalNameDesc"] = "internalName_DESC";
  HomepageBannersCollectionOrder2["KeyAsc"] = "key_ASC";
  HomepageBannersCollectionOrder2["KeyDesc"] = "key_DESC";
  HomepageBannersCollectionOrder2["ShowAgainAsc"] = "showAgain_ASC";
  HomepageBannersCollectionOrder2["ShowAgainDesc"] = "showAgain_DESC";
  HomepageBannersCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HomepageBannersCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HomepageBannersCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HomepageBannersCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HomepageBannersCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HomepageBannersCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HomepageBannersCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HomepageBannersCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HomepageBannersCollectionOrder2;
})(HomepageBannersCollectionOrder || {});
var HomepageOrder = /* @__PURE__ */ ((HomepageOrder2) => {
  HomepageOrder2["IdAsc"] = "id_ASC";
  HomepageOrder2["IdDesc"] = "id_DESC";
  HomepageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HomepageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HomepageOrder2["SysIdAsc"] = "sys_id_ASC";
  HomepageOrder2["SysIdDesc"] = "sys_id_DESC";
  HomepageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HomepageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HomepageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HomepageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HomepageOrder2;
})(HomepageOrder || {});
var HomepageSeoInterlinkingCollectionOrder = /* @__PURE__ */ ((HomepageSeoInterlinkingCollectionOrder2) => {
  HomepageSeoInterlinkingCollectionOrder2["HeadingAsc"] = "heading_ASC";
  HomepageSeoInterlinkingCollectionOrder2["HeadingDesc"] = "heading_DESC";
  HomepageSeoInterlinkingCollectionOrder2["IdAsc"] = "id_ASC";
  HomepageSeoInterlinkingCollectionOrder2["IdDesc"] = "id_DESC";
  HomepageSeoInterlinkingCollectionOrder2["KeyAsc"] = "key_ASC";
  HomepageSeoInterlinkingCollectionOrder2["KeyDesc"] = "key_DESC";
  HomepageSeoInterlinkingCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HomepageSeoInterlinkingCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HomepageSeoInterlinkingCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HomepageSeoInterlinkingCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HomepageSeoInterlinkingCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HomepageSeoInterlinkingCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HomepageSeoInterlinkingCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HomepageSeoInterlinkingCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HomepageSeoInterlinkingCollectionOrder2;
})(HomepageSeoInterlinkingCollectionOrder || {});
var HowItWorksOrder = /* @__PURE__ */ ((HowItWorksOrder2) => {
  HowItWorksOrder2["HeadingAsc"] = "heading_ASC";
  HowItWorksOrder2["HeadingDesc"] = "heading_DESC";
  HowItWorksOrder2["SubHeadingAsc"] = "subHeading_ASC";
  HowItWorksOrder2["SubHeadingDesc"] = "subHeading_DESC";
  HowItWorksOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HowItWorksOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HowItWorksOrder2["SysIdAsc"] = "sys_id_ASC";
  HowItWorksOrder2["SysIdDesc"] = "sys_id_DESC";
  HowItWorksOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HowItWorksOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HowItWorksOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HowItWorksOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HowItWorksOrder2;
})(HowItWorksOrder || {});
var HowItWorksStepsCollectionOrder = /* @__PURE__ */ ((HowItWorksStepsCollectionOrder2) => {
  HowItWorksStepsCollectionOrder2["HeadingAsc"] = "heading_ASC";
  HowItWorksStepsCollectionOrder2["HeadingDesc"] = "heading_DESC";
  HowItWorksStepsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  HowItWorksStepsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  HowItWorksStepsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  HowItWorksStepsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  HowItWorksStepsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  HowItWorksStepsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  HowItWorksStepsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  HowItWorksStepsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return HowItWorksStepsCollectionOrder2;
})(HowItWorksStepsCollectionOrder || {});
var IconOrder = /* @__PURE__ */ ((IconOrder2) => {
  IconOrder2["IconNameAsc"] = "iconName_ASC";
  IconOrder2["IconNameDesc"] = "iconName_DESC";
  IconOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  IconOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  IconOrder2["SysIdAsc"] = "sys_id_ASC";
  IconOrder2["SysIdDesc"] = "sys_id_DESC";
  IconOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  IconOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  IconOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  IconOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return IconOrder2;
})(IconOrder || {});
var ImageFormat = /* @__PURE__ */ ((ImageFormat2) => {
  ImageFormat2["Avif"] = "AVIF";
  ImageFormat2["Jpg"] = "JPG";
  ImageFormat2["JpgProgressive"] = "JPG_PROGRESSIVE";
  ImageFormat2["Png"] = "PNG";
  ImageFormat2["Png8"] = "PNG8";
  ImageFormat2["Webp"] = "WEBP";
  return ImageFormat2;
})(ImageFormat || {});
var ImageResizeFocus = /* @__PURE__ */ ((ImageResizeFocus2) => {
  ImageResizeFocus2["Bottom"] = "BOTTOM";
  ImageResizeFocus2["BottomLeft"] = "BOTTOM_LEFT";
  ImageResizeFocus2["BottomRight"] = "BOTTOM_RIGHT";
  ImageResizeFocus2["Center"] = "CENTER";
  ImageResizeFocus2["Face"] = "FACE";
  ImageResizeFocus2["Faces"] = "FACES";
  ImageResizeFocus2["Left"] = "LEFT";
  ImageResizeFocus2["Right"] = "RIGHT";
  ImageResizeFocus2["Top"] = "TOP";
  ImageResizeFocus2["TopLeft"] = "TOP_LEFT";
  ImageResizeFocus2["TopRight"] = "TOP_RIGHT";
  return ImageResizeFocus2;
})(ImageResizeFocus || {});
var ImageResizeStrategy = /* @__PURE__ */ ((ImageResizeStrategy2) => {
  ImageResizeStrategy2["Crop"] = "CROP";
  ImageResizeStrategy2["Fill"] = "FILL";
  ImageResizeStrategy2["Fit"] = "FIT";
  ImageResizeStrategy2["Pad"] = "PAD";
  ImageResizeStrategy2["Scale"] = "SCALE";
  ImageResizeStrategy2["Thumb"] = "THUMB";
  return ImageResizeStrategy2;
})(ImageResizeStrategy || {});
var JumboCtaOrder = /* @__PURE__ */ ((JumboCtaOrder2) => {
  JumboCtaOrder2["CtaTextAsc"] = "ctaText_ASC";
  JumboCtaOrder2["CtaTextDesc"] = "ctaText_DESC";
  JumboCtaOrder2["HeadingAsc"] = "heading_ASC";
  JumboCtaOrder2["HeadingDesc"] = "heading_DESC";
  JumboCtaOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  JumboCtaOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  JumboCtaOrder2["SysIdAsc"] = "sys_id_ASC";
  JumboCtaOrder2["SysIdDesc"] = "sys_id_DESC";
  JumboCtaOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  JumboCtaOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  JumboCtaOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  JumboCtaOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return JumboCtaOrder2;
})(JumboCtaOrder || {});
var LandingPageStatisticsFiguresCollectionOrder = /* @__PURE__ */ ((LandingPageStatisticsFiguresCollectionOrder2) => {
  LandingPageStatisticsFiguresCollectionOrder2["HeadingAsc"] = "heading_ASC";
  LandingPageStatisticsFiguresCollectionOrder2["HeadingDesc"] = "heading_DESC";
  LandingPageStatisticsFiguresCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LandingPageStatisticsFiguresCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LandingPageStatisticsFiguresCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LandingPageStatisticsFiguresCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LandingPageStatisticsFiguresCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LandingPageStatisticsFiguresCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LandingPageStatisticsFiguresCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LandingPageStatisticsFiguresCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LandingPageStatisticsFiguresCollectionOrder2;
})(LandingPageStatisticsFiguresCollectionOrder || {});
var LandingPageStatisticsOrder = /* @__PURE__ */ ((LandingPageStatisticsOrder2) => {
  LandingPageStatisticsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LandingPageStatisticsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LandingPageStatisticsOrder2["SysIdAsc"] = "sys_id_ASC";
  LandingPageStatisticsOrder2["SysIdDesc"] = "sys_id_DESC";
  LandingPageStatisticsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LandingPageStatisticsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LandingPageStatisticsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LandingPageStatisticsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LandingPageStatisticsOrder2;
})(LandingPageStatisticsOrder || {});
var LeadEnrichmentFormBuilderOrder = /* @__PURE__ */ ((LeadEnrichmentFormBuilderOrder2) => {
  LeadEnrichmentFormBuilderOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormBuilderOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormBuilderOrder2["PrefaceAsc"] = "preface_ASC";
  LeadEnrichmentFormBuilderOrder2["PrefaceDesc"] = "preface_DESC";
  LeadEnrichmentFormBuilderOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormBuilderOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormBuilderOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormBuilderOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormBuilderOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormBuilderOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormBuilderOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormBuilderOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LeadEnrichmentFormBuilderOrder2;
})(LeadEnrichmentFormBuilderOrder || {});
var LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder = /* @__PURE__ */ ((LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2) => {
  LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceAsc"] = "preface_ASC";
  LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceDesc"] = "preface_DESC";
  LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2;
})(LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder || {});
var LeadEnrichmentFormConsumerImagesOrder = /* @__PURE__ */ ((LeadEnrichmentFormConsumerImagesOrder2) => {
  LeadEnrichmentFormConsumerImagesOrder2["FormatAsc"] = "format_ASC";
  LeadEnrichmentFormConsumerImagesOrder2["FormatDesc"] = "format_DESC";
  LeadEnrichmentFormConsumerImagesOrder2["LabelAndDescriptionAsc"] = "labelAndDescription_ASC";
  LeadEnrichmentFormConsumerImagesOrder2["LabelAndDescriptionDesc"] = "labelAndDescription_DESC";
  LeadEnrichmentFormConsumerImagesOrder2["MaximumAsc"] = "maximum_ASC";
  LeadEnrichmentFormConsumerImagesOrder2["MaximumDesc"] = "maximum_DESC";
  LeadEnrichmentFormConsumerImagesOrder2["MinimumAsc"] = "minimum_ASC";
  LeadEnrichmentFormConsumerImagesOrder2["MinimumDesc"] = "minimum_DESC";
  LeadEnrichmentFormConsumerImagesOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormConsumerImagesOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormConsumerImagesOrder2["RequiredAsc"] = "required_ASC";
  LeadEnrichmentFormConsumerImagesOrder2["RequiredDesc"] = "required_DESC";
  LeadEnrichmentFormConsumerImagesOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormConsumerImagesOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormConsumerImagesOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormConsumerImagesOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormConsumerImagesOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormConsumerImagesOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormConsumerImagesOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormConsumerImagesOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LeadEnrichmentFormConsumerImagesOrder2["TypeAsc"] = "type_ASC";
  LeadEnrichmentFormConsumerImagesOrder2["TypeDesc"] = "type_DESC";
  return LeadEnrichmentFormConsumerImagesOrder2;
})(LeadEnrichmentFormConsumerImagesOrder || {});
var LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder = /* @__PURE__ */ ((LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2) => {
  LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceAsc"] = "preface_ASC";
  LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceDesc"] = "preface_DESC";
  LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2;
})(LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder || {});
var LeadEnrichmentFormJobDescriptionOrder = /* @__PURE__ */ ((LeadEnrichmentFormJobDescriptionOrder2) => {
  LeadEnrichmentFormJobDescriptionOrder2["FormatAsc"] = "format_ASC";
  LeadEnrichmentFormJobDescriptionOrder2["FormatDesc"] = "format_DESC";
  LeadEnrichmentFormJobDescriptionOrder2["LabelAndDescriptionAsc"] = "labelAndDescription_ASC";
  LeadEnrichmentFormJobDescriptionOrder2["LabelAndDescriptionDesc"] = "labelAndDescription_DESC";
  LeadEnrichmentFormJobDescriptionOrder2["MaximumAsc"] = "maximum_ASC";
  LeadEnrichmentFormJobDescriptionOrder2["MaximumDesc"] = "maximum_DESC";
  LeadEnrichmentFormJobDescriptionOrder2["MinimumAsc"] = "minimum_ASC";
  LeadEnrichmentFormJobDescriptionOrder2["MinimumDesc"] = "minimum_DESC";
  LeadEnrichmentFormJobDescriptionOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormJobDescriptionOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormJobDescriptionOrder2["RequiredAsc"] = "required_ASC";
  LeadEnrichmentFormJobDescriptionOrder2["RequiredDesc"] = "required_DESC";
  LeadEnrichmentFormJobDescriptionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormJobDescriptionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormJobDescriptionOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormJobDescriptionOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormJobDescriptionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormJobDescriptionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormJobDescriptionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormJobDescriptionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LeadEnrichmentFormJobDescriptionOrder2["TypeAsc"] = "type_ASC";
  LeadEnrichmentFormJobDescriptionOrder2["TypeDesc"] = "type_DESC";
  return LeadEnrichmentFormJobDescriptionOrder2;
})(LeadEnrichmentFormJobDescriptionOrder || {});
var LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder = /* @__PURE__ */ ((LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2) => {
  LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceAsc"] = "preface_ASC";
  LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceDesc"] = "preface_DESC";
  LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2;
})(LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder || {});
var LeadEnrichmentFormJobPreferredStartsOrder = /* @__PURE__ */ ((LeadEnrichmentFormJobPreferredStartsOrder2) => {
  LeadEnrichmentFormJobPreferredStartsOrder2["FormatAsc"] = "format_ASC";
  LeadEnrichmentFormJobPreferredStartsOrder2["FormatDesc"] = "format_DESC";
  LeadEnrichmentFormJobPreferredStartsOrder2["LabelAndDescriptionAsc"] = "labelAndDescription_ASC";
  LeadEnrichmentFormJobPreferredStartsOrder2["LabelAndDescriptionDesc"] = "labelAndDescription_DESC";
  LeadEnrichmentFormJobPreferredStartsOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormJobPreferredStartsOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormJobPreferredStartsOrder2["RequiredAsc"] = "required_ASC";
  LeadEnrichmentFormJobPreferredStartsOrder2["RequiredDesc"] = "required_DESC";
  LeadEnrichmentFormJobPreferredStartsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormJobPreferredStartsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormJobPreferredStartsOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormJobPreferredStartsOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormJobPreferredStartsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormJobPreferredStartsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormJobPreferredStartsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormJobPreferredStartsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LeadEnrichmentFormJobPreferredStartsOrder2["TypeAsc"] = "type_ASC";
  LeadEnrichmentFormJobPreferredStartsOrder2["TypeDesc"] = "type_DESC";
  return LeadEnrichmentFormJobPreferredStartsOrder2;
})(LeadEnrichmentFormJobPreferredStartsOrder || {});
var LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder = /* @__PURE__ */ ((LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2) => {
  LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceAsc"] = "preface_ASC";
  LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceDesc"] = "preface_DESC";
  LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2;
})(LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder || {});
var LeadEnrichmentFormMultiSelectOrder = /* @__PURE__ */ ((LeadEnrichmentFormMultiSelectOrder2) => {
  LeadEnrichmentFormMultiSelectOrder2["AllowOtherAsc"] = "allowOther_ASC";
  LeadEnrichmentFormMultiSelectOrder2["AllowOtherDesc"] = "allowOther_DESC";
  LeadEnrichmentFormMultiSelectOrder2["FormatAsc"] = "format_ASC";
  LeadEnrichmentFormMultiSelectOrder2["FormatDesc"] = "format_DESC";
  LeadEnrichmentFormMultiSelectOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormMultiSelectOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormMultiSelectOrder2["RequiredAsc"] = "required_ASC";
  LeadEnrichmentFormMultiSelectOrder2["RequiredDesc"] = "required_DESC";
  LeadEnrichmentFormMultiSelectOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormMultiSelectOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormMultiSelectOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormMultiSelectOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormMultiSelectOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormMultiSelectOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormMultiSelectOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormMultiSelectOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LeadEnrichmentFormMultiSelectOrder2["TypeAsc"] = "type_ASC";
  LeadEnrichmentFormMultiSelectOrder2["TypeDesc"] = "type_DESC";
  return LeadEnrichmentFormMultiSelectOrder2;
})(LeadEnrichmentFormMultiSelectOrder || {});
var LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder = /* @__PURE__ */ ((LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2) => {
  LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceAsc"] = "preface_ASC";
  LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceDesc"] = "preface_DESC";
  LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2;
})(LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder || {});
var LeadEnrichmentFormMultiVisualSelectionOrder = /* @__PURE__ */ ((LeadEnrichmentFormMultiVisualSelectionOrder2) => {
  LeadEnrichmentFormMultiVisualSelectionOrder2["AllowOtherAsc"] = "allowOther_ASC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["AllowOtherDesc"] = "allowOther_DESC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["FormatAsc"] = "format_ASC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["FormatDesc"] = "format_DESC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["LabelAndDescriptionAsc"] = "labelAndDescription_ASC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["LabelAndDescriptionDesc"] = "labelAndDescription_DESC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["RequiredAsc"] = "required_ASC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["RequiredDesc"] = "required_DESC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["TypeAsc"] = "type_ASC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["TypeDesc"] = "type_DESC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["VisualSizeAsc"] = "visualSize_ASC";
  LeadEnrichmentFormMultiVisualSelectionOrder2["VisualSizeDesc"] = "visualSize_DESC";
  return LeadEnrichmentFormMultiVisualSelectionOrder2;
})(LeadEnrichmentFormMultiVisualSelectionOrder || {});
var LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder = /* @__PURE__ */ ((LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2) => {
  LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceAsc"] = "preface_ASC";
  LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceDesc"] = "preface_DESC";
  LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2;
})(LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder || {});
var LeadEnrichmentFormOwnershipStatusOrder = /* @__PURE__ */ ((LeadEnrichmentFormOwnershipStatusOrder2) => {
  LeadEnrichmentFormOwnershipStatusOrder2["AllowOtherAsc"] = "allowOther_ASC";
  LeadEnrichmentFormOwnershipStatusOrder2["AllowOtherDesc"] = "allowOther_DESC";
  LeadEnrichmentFormOwnershipStatusOrder2["FormatAsc"] = "format_ASC";
  LeadEnrichmentFormOwnershipStatusOrder2["FormatDesc"] = "format_DESC";
  LeadEnrichmentFormOwnershipStatusOrder2["LabelAndDescriptionAsc"] = "labelAndDescription_ASC";
  LeadEnrichmentFormOwnershipStatusOrder2["LabelAndDescriptionDesc"] = "labelAndDescription_DESC";
  LeadEnrichmentFormOwnershipStatusOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormOwnershipStatusOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormOwnershipStatusOrder2["RequiredAsc"] = "required_ASC";
  LeadEnrichmentFormOwnershipStatusOrder2["RequiredDesc"] = "required_DESC";
  LeadEnrichmentFormOwnershipStatusOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormOwnershipStatusOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormOwnershipStatusOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormOwnershipStatusOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormOwnershipStatusOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormOwnershipStatusOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormOwnershipStatusOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormOwnershipStatusOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LeadEnrichmentFormOwnershipStatusOrder2["TypeAsc"] = "type_ASC";
  LeadEnrichmentFormOwnershipStatusOrder2["TypeDesc"] = "type_DESC";
  return LeadEnrichmentFormOwnershipStatusOrder2;
})(LeadEnrichmentFormOwnershipStatusOrder || {});
var LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder = /* @__PURE__ */ ((LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2) => {
  LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceAsc"] = "preface_ASC";
  LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceDesc"] = "preface_DESC";
  LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2;
})(LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder || {});
var LeadEnrichmentFormQuestionSingleSelectOrder = /* @__PURE__ */ ((LeadEnrichmentFormQuestionSingleSelectOrder2) => {
  LeadEnrichmentFormQuestionSingleSelectOrder2["AllowOtherAsc"] = "allowOther_ASC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["AllowOtherDesc"] = "allowOther_DESC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["FormatAsc"] = "format_ASC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["FormatDesc"] = "format_DESC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["LabelAndDescriptionAsc"] = "labelAndDescription_ASC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["LabelAndDescriptionDesc"] = "labelAndDescription_DESC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["RequiredAsc"] = "required_ASC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["RequiredDesc"] = "required_DESC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["TypeAsc"] = "type_ASC";
  LeadEnrichmentFormQuestionSingleSelectOrder2["TypeDesc"] = "type_DESC";
  return LeadEnrichmentFormQuestionSingleSelectOrder2;
})(LeadEnrichmentFormQuestionSingleSelectOrder || {});
var LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder = /* @__PURE__ */ ((LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2) => {
  LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceAsc"] = "preface_ASC";
  LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceDesc"] = "preface_DESC";
  LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2;
})(LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder || {});
var LeadEnrichmentFormSingleVisualSelectionOrder = /* @__PURE__ */ ((LeadEnrichmentFormSingleVisualSelectionOrder2) => {
  LeadEnrichmentFormSingleVisualSelectionOrder2["AllowOtherAsc"] = "allowOther_ASC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["AllowOtherDesc"] = "allowOther_DESC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["FormatAsc"] = "format_ASC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["FormatDesc"] = "format_DESC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["LabelAndDescriptionAsc"] = "labelAndDescription_ASC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["LabelAndDescriptionDesc"] = "labelAndDescription_DESC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["RequiredAsc"] = "required_ASC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["RequiredDesc"] = "required_DESC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["TypeAsc"] = "type_ASC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["TypeDesc"] = "type_DESC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["VisualSizeAsc"] = "visualSize_ASC";
  LeadEnrichmentFormSingleVisualSelectionOrder2["VisualSizeDesc"] = "visualSize_DESC";
  return LeadEnrichmentFormSingleVisualSelectionOrder2;
})(LeadEnrichmentFormSingleVisualSelectionOrder || {});
var LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder = /* @__PURE__ */ ((LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2) => {
  LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceAsc"] = "preface_ASC";
  LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["PrefaceDesc"] = "preface_DESC";
  LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder2;
})(LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder || {});
var LeadEnrichmentFormTextFieldOrder = /* @__PURE__ */ ((LeadEnrichmentFormTextFieldOrder2) => {
  LeadEnrichmentFormTextFieldOrder2["FormatAsc"] = "format_ASC";
  LeadEnrichmentFormTextFieldOrder2["FormatDesc"] = "format_DESC";
  LeadEnrichmentFormTextFieldOrder2["LabelAndDescriptionAsc"] = "labelAndDescription_ASC";
  LeadEnrichmentFormTextFieldOrder2["LabelAndDescriptionDesc"] = "labelAndDescription_DESC";
  LeadEnrichmentFormTextFieldOrder2["MaximumAsc"] = "maximum_ASC";
  LeadEnrichmentFormTextFieldOrder2["MaximumDesc"] = "maximum_DESC";
  LeadEnrichmentFormTextFieldOrder2["MinimumAsc"] = "minimum_ASC";
  LeadEnrichmentFormTextFieldOrder2["MinimumDesc"] = "minimum_DESC";
  LeadEnrichmentFormTextFieldOrder2["NameAsc"] = "name_ASC";
  LeadEnrichmentFormTextFieldOrder2["NameDesc"] = "name_DESC";
  LeadEnrichmentFormTextFieldOrder2["RequiredAsc"] = "required_ASC";
  LeadEnrichmentFormTextFieldOrder2["RequiredDesc"] = "required_DESC";
  LeadEnrichmentFormTextFieldOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LeadEnrichmentFormTextFieldOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LeadEnrichmentFormTextFieldOrder2["SysIdAsc"] = "sys_id_ASC";
  LeadEnrichmentFormTextFieldOrder2["SysIdDesc"] = "sys_id_DESC";
  LeadEnrichmentFormTextFieldOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LeadEnrichmentFormTextFieldOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LeadEnrichmentFormTextFieldOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LeadEnrichmentFormTextFieldOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  LeadEnrichmentFormTextFieldOrder2["TypeAsc"] = "type_ASC";
  LeadEnrichmentFormTextFieldOrder2["TypeDesc"] = "type_DESC";
  return LeadEnrichmentFormTextFieldOrder2;
})(LeadEnrichmentFormTextFieldOrder || {});
var LinksGroupLinkingCollectionsDefaultInterlinksCollectionOrder = /* @__PURE__ */ ((LinksGroupLinkingCollectionsDefaultInterlinksCollectionOrder2) => {
  LinksGroupLinkingCollectionsDefaultInterlinksCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinksGroupLinkingCollectionsDefaultInterlinksCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinksGroupLinkingCollectionsDefaultInterlinksCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinksGroupLinkingCollectionsDefaultInterlinksCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinksGroupLinkingCollectionsDefaultInterlinksCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinksGroupLinkingCollectionsDefaultInterlinksCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinksGroupLinkingCollectionsDefaultInterlinksCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinksGroupLinkingCollectionsDefaultInterlinksCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinksGroupLinkingCollectionsDefaultInterlinksCollectionOrder2;
})(LinksGroupLinkingCollectionsDefaultInterlinksCollectionOrder || {});
var LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder = /* @__PURE__ */ ((LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder2) => {
  LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["BlurbHeadingAsc"] = "blurbHeading_ASC";
  LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["BlurbHeadingDesc"] = "blurbHeading_DESC";
  LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["PageHeadingH1Asc"] = "pageHeadingH1_ASC";
  LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["PageHeadingH1Desc"] = "pageHeadingH1_DESC";
  LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["PageNameAsc"] = "pageName_ASC";
  LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["PageNameDesc"] = "pageName_DESC";
  LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder2;
})(LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder || {});
var LinksGroupLinkingCollectionsHomepageCollectionOrder = /* @__PURE__ */ ((LinksGroupLinkingCollectionsHomepageCollectionOrder2) => {
  LinksGroupLinkingCollectionsHomepageCollectionOrder2["IdAsc"] = "id_ASC";
  LinksGroupLinkingCollectionsHomepageCollectionOrder2["IdDesc"] = "id_DESC";
  LinksGroupLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinksGroupLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinksGroupLinkingCollectionsHomepageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinksGroupLinkingCollectionsHomepageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinksGroupLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinksGroupLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinksGroupLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinksGroupLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinksGroupLinkingCollectionsHomepageCollectionOrder2;
})(LinksGroupLinkingCollectionsHomepageCollectionOrder || {});
var LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder = /* @__PURE__ */ ((LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder2) => {
  LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder2["BlurbHeadingAsc"] = "blurbHeading_ASC";
  LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder2["BlurbHeadingDesc"] = "blurbHeading_DESC";
  LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder2["PageHeadingH1Asc"] = "pageHeadingH1_ASC";
  LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder2["PageHeadingH1Desc"] = "pageHeadingH1_DESC";
  LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder2["PageNameAsc"] = "pageName_ASC";
  LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder2["PageNameDesc"] = "pageName_DESC";
  LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder2;
})(LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder || {});
var LinksGroupLinkingCollectionsSearchLandingPageFallbackContentCollectionOrder = /* @__PURE__ */ ((LinksGroupLinkingCollectionsSearchLandingPageFallbackContentCollectionOrder2) => {
  LinksGroupLinkingCollectionsSearchLandingPageFallbackContentCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinksGroupLinkingCollectionsSearchLandingPageFallbackContentCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinksGroupLinkingCollectionsSearchLandingPageFallbackContentCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  LinksGroupLinkingCollectionsSearchLandingPageFallbackContentCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  LinksGroupLinkingCollectionsSearchLandingPageFallbackContentCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinksGroupLinkingCollectionsSearchLandingPageFallbackContentCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinksGroupLinkingCollectionsSearchLandingPageFallbackContentCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinksGroupLinkingCollectionsSearchLandingPageFallbackContentCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinksGroupLinkingCollectionsSearchLandingPageFallbackContentCollectionOrder2;
})(LinksGroupLinkingCollectionsSearchLandingPageFallbackContentCollectionOrder || {});
var LinksGroupOrder = /* @__PURE__ */ ((LinksGroupOrder2) => {
  LinksGroupOrder2["HeadingAsc"] = "heading_ASC";
  LinksGroupOrder2["HeadingDesc"] = "heading_DESC";
  LinksGroupOrder2["IdAsc"] = "id_ASC";
  LinksGroupOrder2["IdDesc"] = "id_DESC";
  LinksGroupOrder2["KeyAsc"] = "key_ASC";
  LinksGroupOrder2["KeyDesc"] = "key_DESC";
  LinksGroupOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  LinksGroupOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  LinksGroupOrder2["SysIdAsc"] = "sys_id_ASC";
  LinksGroupOrder2["SysIdDesc"] = "sys_id_DESC";
  LinksGroupOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  LinksGroupOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  LinksGroupOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  LinksGroupOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return LinksGroupOrder2;
})(LinksGroupOrder || {});
var ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder = /* @__PURE__ */ ((ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2) => {
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["BackgroundAsc"] = "background_ASC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["BackgroundDesc"] = "background_DESC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["HeadingAsc"] = "heading_ASC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["HeadingDesc"] = "heading_DESC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["IdAsc"] = "id_ASC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["IdDesc"] = "id_DESC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["SubHeadingAsc"] = "subHeading_ASC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["SubHeadingDesc"] = "subHeading_DESC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["VariantAsc"] = "variant_ASC";
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2["VariantDesc"] = "variant_DESC";
  return ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder2;
})(ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder || {});
var ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder = /* @__PURE__ */ ((ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2) => {
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["BannerHeadingAsc"] = "bannerHeading_ASC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["BannerHeadingDesc"] = "bannerHeading_DESC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["BannerRatingAsc"] = "bannerRating_ASC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["BannerRatingDesc"] = "bannerRating_DESC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["BannerSubHeadingAsc"] = "bannerSubHeading_ASC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["BannerSubHeadingDesc"] = "bannerSubHeading_DESC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["HeadingAsc"] = "heading_ASC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["HeadingDesc"] = "heading_DESC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["IdAsc"] = "id_ASC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["IdDesc"] = "id_DESC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder2;
})(ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder || {});
var ListItemLinkingCollectionsHowItWorksCollectionOrder = /* @__PURE__ */ ((ListItemLinkingCollectionsHowItWorksCollectionOrder2) => {
  ListItemLinkingCollectionsHowItWorksCollectionOrder2["HeadingAsc"] = "heading_ASC";
  ListItemLinkingCollectionsHowItWorksCollectionOrder2["HeadingDesc"] = "heading_DESC";
  ListItemLinkingCollectionsHowItWorksCollectionOrder2["SubHeadingAsc"] = "subHeading_ASC";
  ListItemLinkingCollectionsHowItWorksCollectionOrder2["SubHeadingDesc"] = "subHeading_DESC";
  ListItemLinkingCollectionsHowItWorksCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ListItemLinkingCollectionsHowItWorksCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ListItemLinkingCollectionsHowItWorksCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ListItemLinkingCollectionsHowItWorksCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ListItemLinkingCollectionsHowItWorksCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ListItemLinkingCollectionsHowItWorksCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ListItemLinkingCollectionsHowItWorksCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ListItemLinkingCollectionsHowItWorksCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ListItemLinkingCollectionsHowItWorksCollectionOrder2;
})(ListItemLinkingCollectionsHowItWorksCollectionOrder || {});
var ListItemLinkingCollectionsLandingPageStatisticsCollectionOrder = /* @__PURE__ */ ((ListItemLinkingCollectionsLandingPageStatisticsCollectionOrder2) => {
  ListItemLinkingCollectionsLandingPageStatisticsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ListItemLinkingCollectionsLandingPageStatisticsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ListItemLinkingCollectionsLandingPageStatisticsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ListItemLinkingCollectionsLandingPageStatisticsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ListItemLinkingCollectionsLandingPageStatisticsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ListItemLinkingCollectionsLandingPageStatisticsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ListItemLinkingCollectionsLandingPageStatisticsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ListItemLinkingCollectionsLandingPageStatisticsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ListItemLinkingCollectionsLandingPageStatisticsCollectionOrder2;
})(ListItemLinkingCollectionsLandingPageStatisticsCollectionOrder || {});
var ListItemLinkingCollectionsTradeTraitsCollectionOrder = /* @__PURE__ */ ((ListItemLinkingCollectionsTradeTraitsCollectionOrder2) => {
  ListItemLinkingCollectionsTradeTraitsCollectionOrder2["FootnoteAsc"] = "footnote_ASC";
  ListItemLinkingCollectionsTradeTraitsCollectionOrder2["FootnoteDesc"] = "footnote_DESC";
  ListItemLinkingCollectionsTradeTraitsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ListItemLinkingCollectionsTradeTraitsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ListItemLinkingCollectionsTradeTraitsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ListItemLinkingCollectionsTradeTraitsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ListItemLinkingCollectionsTradeTraitsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ListItemLinkingCollectionsTradeTraitsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ListItemLinkingCollectionsTradeTraitsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ListItemLinkingCollectionsTradeTraitsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ListItemLinkingCollectionsTradeTraitsCollectionOrder2;
})(ListItemLinkingCollectionsTradeTraitsCollectionOrder || {});
var ListItemOrder = /* @__PURE__ */ ((ListItemOrder2) => {
  ListItemOrder2["HeadingAsc"] = "heading_ASC";
  ListItemOrder2["HeadingDesc"] = "heading_DESC";
  ListItemOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ListItemOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ListItemOrder2["SysIdAsc"] = "sys_id_ASC";
  ListItemOrder2["SysIdDesc"] = "sys_id_DESC";
  ListItemOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ListItemOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ListItemOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ListItemOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ListItemOrder2;
})(ListItemOrder || {});
var MediaBannerOrder = /* @__PURE__ */ ((MediaBannerOrder2) => {
  MediaBannerOrder2["HeadingAsc"] = "heading_ASC";
  MediaBannerOrder2["HeadingDesc"] = "heading_DESC";
  MediaBannerOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  MediaBannerOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  MediaBannerOrder2["SysIdAsc"] = "sys_id_ASC";
  MediaBannerOrder2["SysIdDesc"] = "sys_id_DESC";
  MediaBannerOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  MediaBannerOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  MediaBannerOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  MediaBannerOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return MediaBannerOrder2;
})(MediaBannerOrder || {});
var PageOrder = /* @__PURE__ */ ((PageOrder2) => {
  PageOrder2["SlugAsc"] = "slug_ASC";
  PageOrder2["SlugDesc"] = "slug_DESC";
  PageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PageOrder2["SysIdAsc"] = "sys_id_ASC";
  PageOrder2["SysIdDesc"] = "sys_id_DESC";
  PageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  PageOrder2["TitleAsc"] = "title_ASC";
  PageOrder2["TitleDesc"] = "title_DESC";
  return PageOrder2;
})(PageOrder || {});
var PopularSearchesCategoriesCollectionOrder = /* @__PURE__ */ ((PopularSearchesCategoriesCollectionOrder2) => {
  PopularSearchesCategoriesCollectionOrder2["CategoryIdAsc"] = "categoryId_ASC";
  PopularSearchesCategoriesCollectionOrder2["CategoryIdDesc"] = "categoryId_DESC";
  PopularSearchesCategoriesCollectionOrder2["LabelAsc"] = "label_ASC";
  PopularSearchesCategoriesCollectionOrder2["LabelDesc"] = "label_DESC";
  PopularSearchesCategoriesCollectionOrder2["LifecycleStageAsc"] = "lifecycleStage_ASC";
  PopularSearchesCategoriesCollectionOrder2["LifecycleStageDesc"] = "lifecycleStage_DESC";
  PopularSearchesCategoriesCollectionOrder2["LinkOrUrlAsc"] = "linkOrUrl_ASC";
  PopularSearchesCategoriesCollectionOrder2["LinkOrUrlDesc"] = "linkOrUrl_DESC";
  PopularSearchesCategoriesCollectionOrder2["SlugAsc"] = "slug_ASC";
  PopularSearchesCategoriesCollectionOrder2["SlugDesc"] = "slug_DESC";
  PopularSearchesCategoriesCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PopularSearchesCategoriesCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PopularSearchesCategoriesCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PopularSearchesCategoriesCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PopularSearchesCategoriesCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PopularSearchesCategoriesCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PopularSearchesCategoriesCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PopularSearchesCategoriesCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PopularSearchesCategoriesCollectionOrder2;
})(PopularSearchesCategoriesCollectionOrder || {});
var PopularSearchesLinkingCollectionsHomepageCollectionOrder = /* @__PURE__ */ ((PopularSearchesLinkingCollectionsHomepageCollectionOrder2) => {
  PopularSearchesLinkingCollectionsHomepageCollectionOrder2["IdAsc"] = "id_ASC";
  PopularSearchesLinkingCollectionsHomepageCollectionOrder2["IdDesc"] = "id_DESC";
  PopularSearchesLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PopularSearchesLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PopularSearchesLinkingCollectionsHomepageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  PopularSearchesLinkingCollectionsHomepageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  PopularSearchesLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PopularSearchesLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PopularSearchesLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PopularSearchesLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PopularSearchesLinkingCollectionsHomepageCollectionOrder2;
})(PopularSearchesLinkingCollectionsHomepageCollectionOrder || {});
var PopularSearchesOrder = /* @__PURE__ */ ((PopularSearchesOrder2) => {
  PopularSearchesOrder2["HeadingAsc"] = "heading_ASC";
  PopularSearchesOrder2["HeadingDesc"] = "heading_DESC";
  PopularSearchesOrder2["IdAsc"] = "id_ASC";
  PopularSearchesOrder2["IdDesc"] = "id_DESC";
  PopularSearchesOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  PopularSearchesOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  PopularSearchesOrder2["SysIdAsc"] = "sys_id_ASC";
  PopularSearchesOrder2["SysIdDesc"] = "sys_id_DESC";
  PopularSearchesOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  PopularSearchesOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  PopularSearchesOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  PopularSearchesOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return PopularSearchesOrder2;
})(PopularSearchesOrder || {});
var ProductCategoryContentCollectionOrder = /* @__PURE__ */ ((ProductCategoryContentCollectionOrder2) => {
  ProductCategoryContentCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ProductCategoryContentCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ProductCategoryContentCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ProductCategoryContentCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ProductCategoryContentCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ProductCategoryContentCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ProductCategoryContentCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ProductCategoryContentCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ProductCategoryContentCollectionOrder2["TitleAsc"] = "title_ASC";
  ProductCategoryContentCollectionOrder2["TitleDesc"] = "title_DESC";
  return ProductCategoryContentCollectionOrder2;
})(ProductCategoryContentCollectionOrder || {});
var ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder = /* @__PURE__ */ ((ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder2) => {
  ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder2["NameAsc"] = "name_ASC";
  ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder2["NameDesc"] = "name_DESC";
  ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder2["SlugAsc"] = "slug_ASC";
  ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder2["SlugDesc"] = "slug_DESC";
  ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder2;
})(ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder || {});
var ProductCategoryContentOrder = /* @__PURE__ */ ((ProductCategoryContentOrder2) => {
  ProductCategoryContentOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ProductCategoryContentOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ProductCategoryContentOrder2["SysIdAsc"] = "sys_id_ASC";
  ProductCategoryContentOrder2["SysIdDesc"] = "sys_id_DESC";
  ProductCategoryContentOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ProductCategoryContentOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ProductCategoryContentOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ProductCategoryContentOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ProductCategoryContentOrder2["TitleAsc"] = "title_ASC";
  ProductCategoryContentOrder2["TitleDesc"] = "title_DESC";
  return ProductCategoryContentOrder2;
})(ProductCategoryContentOrder || {});
var ProductCategoryImageLinkingCollectionsProductCategoryContentCollectionOrder = /* @__PURE__ */ ((ProductCategoryImageLinkingCollectionsProductCategoryContentCollectionOrder2) => {
  ProductCategoryImageLinkingCollectionsProductCategoryContentCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ProductCategoryImageLinkingCollectionsProductCategoryContentCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ProductCategoryImageLinkingCollectionsProductCategoryContentCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ProductCategoryImageLinkingCollectionsProductCategoryContentCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ProductCategoryImageLinkingCollectionsProductCategoryContentCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ProductCategoryImageLinkingCollectionsProductCategoryContentCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ProductCategoryImageLinkingCollectionsProductCategoryContentCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ProductCategoryImageLinkingCollectionsProductCategoryContentCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ProductCategoryImageLinkingCollectionsProductCategoryContentCollectionOrder2["TitleAsc"] = "title_ASC";
  ProductCategoryImageLinkingCollectionsProductCategoryContentCollectionOrder2["TitleDesc"] = "title_DESC";
  return ProductCategoryImageLinkingCollectionsProductCategoryContentCollectionOrder2;
})(ProductCategoryImageLinkingCollectionsProductCategoryContentCollectionOrder || {});
var ProductCategoryImageOrder = /* @__PURE__ */ ((ProductCategoryImageOrder2) => {
  ProductCategoryImageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ProductCategoryImageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ProductCategoryImageOrder2["SysIdAsc"] = "sys_id_ASC";
  ProductCategoryImageOrder2["SysIdDesc"] = "sys_id_DESC";
  ProductCategoryImageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ProductCategoryImageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ProductCategoryImageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ProductCategoryImageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ProductCategoryImageOrder2["TitleAsc"] = "title_ASC";
  ProductCategoryImageOrder2["TitleDesc"] = "title_DESC";
  return ProductCategoryImageOrder2;
})(ProductCategoryImageOrder || {});
var ProductCategoryLinkingCollectionsShopCollectionOrder = /* @__PURE__ */ ((ProductCategoryLinkingCollectionsShopCollectionOrder2) => {
  ProductCategoryLinkingCollectionsShopCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ProductCategoryLinkingCollectionsShopCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ProductCategoryLinkingCollectionsShopCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ProductCategoryLinkingCollectionsShopCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ProductCategoryLinkingCollectionsShopCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ProductCategoryLinkingCollectionsShopCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ProductCategoryLinkingCollectionsShopCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ProductCategoryLinkingCollectionsShopCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ProductCategoryLinkingCollectionsShopCollectionOrder2["VersionAsc"] = "version_ASC";
  ProductCategoryLinkingCollectionsShopCollectionOrder2["VersionDesc"] = "version_DESC";
  return ProductCategoryLinkingCollectionsShopCollectionOrder2;
})(ProductCategoryLinkingCollectionsShopCollectionOrder || {});
var ProductCategoryOrder = /* @__PURE__ */ ((ProductCategoryOrder2) => {
  ProductCategoryOrder2["NameAsc"] = "name_ASC";
  ProductCategoryOrder2["NameDesc"] = "name_DESC";
  ProductCategoryOrder2["SlugAsc"] = "slug_ASC";
  ProductCategoryOrder2["SlugDesc"] = "slug_DESC";
  ProductCategoryOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ProductCategoryOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ProductCategoryOrder2["SysIdAsc"] = "sys_id_ASC";
  ProductCategoryOrder2["SysIdDesc"] = "sys_id_DESC";
  ProductCategoryOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ProductCategoryOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ProductCategoryOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ProductCategoryOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ProductCategoryOrder2;
})(ProductCategoryOrder || {});
var ProductCategoryTextBlockLinkingCollectionsProductCategoryContentCollectionOrder = /* @__PURE__ */ ((ProductCategoryTextBlockLinkingCollectionsProductCategoryContentCollectionOrder2) => {
  ProductCategoryTextBlockLinkingCollectionsProductCategoryContentCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ProductCategoryTextBlockLinkingCollectionsProductCategoryContentCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ProductCategoryTextBlockLinkingCollectionsProductCategoryContentCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ProductCategoryTextBlockLinkingCollectionsProductCategoryContentCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ProductCategoryTextBlockLinkingCollectionsProductCategoryContentCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ProductCategoryTextBlockLinkingCollectionsProductCategoryContentCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ProductCategoryTextBlockLinkingCollectionsProductCategoryContentCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ProductCategoryTextBlockLinkingCollectionsProductCategoryContentCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ProductCategoryTextBlockLinkingCollectionsProductCategoryContentCollectionOrder2["TitleAsc"] = "title_ASC";
  ProductCategoryTextBlockLinkingCollectionsProductCategoryContentCollectionOrder2["TitleDesc"] = "title_DESC";
  return ProductCategoryTextBlockLinkingCollectionsProductCategoryContentCollectionOrder2;
})(ProductCategoryTextBlockLinkingCollectionsProductCategoryContentCollectionOrder || {});
var ProductCategoryTextBlockOrder = /* @__PURE__ */ ((ProductCategoryTextBlockOrder2) => {
  ProductCategoryTextBlockOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ProductCategoryTextBlockOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ProductCategoryTextBlockOrder2["SysIdAsc"] = "sys_id_ASC";
  ProductCategoryTextBlockOrder2["SysIdDesc"] = "sys_id_DESC";
  ProductCategoryTextBlockOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ProductCategoryTextBlockOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ProductCategoryTextBlockOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ProductCategoryTextBlockOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ProductCategoryTextBlockOrder2["TitleAsc"] = "title_ASC";
  ProductCategoryTextBlockOrder2["TitleDesc"] = "title_DESC";
  return ProductCategoryTextBlockOrder2;
})(ProductCategoryTextBlockOrder || {});
var ProductPartnerLinkingCollectionsCategoryHeroCollectionOrder = /* @__PURE__ */ ((ProductPartnerLinkingCollectionsCategoryHeroCollectionOrder2) => {
  ProductPartnerLinkingCollectionsCategoryHeroCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ProductPartnerLinkingCollectionsCategoryHeroCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ProductPartnerLinkingCollectionsCategoryHeroCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ProductPartnerLinkingCollectionsCategoryHeroCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ProductPartnerLinkingCollectionsCategoryHeroCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ProductPartnerLinkingCollectionsCategoryHeroCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ProductPartnerLinkingCollectionsCategoryHeroCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ProductPartnerLinkingCollectionsCategoryHeroCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ProductPartnerLinkingCollectionsCategoryHeroCollectionOrder2["TitleAsc"] = "title_ASC";
  ProductPartnerLinkingCollectionsCategoryHeroCollectionOrder2["TitleDesc"] = "title_DESC";
  return ProductPartnerLinkingCollectionsCategoryHeroCollectionOrder2;
})(ProductPartnerLinkingCollectionsCategoryHeroCollectionOrder || {});
var ProductPartnerOrder = /* @__PURE__ */ ((ProductPartnerOrder2) => {
  ProductPartnerOrder2["NameAsc"] = "name_ASC";
  ProductPartnerOrder2["NameDesc"] = "name_DESC";
  ProductPartnerOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ProductPartnerOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ProductPartnerOrder2["SysIdAsc"] = "sys_id_ASC";
  ProductPartnerOrder2["SysIdDesc"] = "sys_id_DESC";
  ProductPartnerOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ProductPartnerOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ProductPartnerOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ProductPartnerOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ProductPartnerOrder2["UrlAsc"] = "url_ASC";
  ProductPartnerOrder2["UrlDesc"] = "url_DESC";
  return ProductPartnerOrder2;
})(ProductPartnerOrder || {});
var QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder = /* @__PURE__ */ ((QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder2) => {
  QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["BlurbHeadingAsc"] = "blurbHeading_ASC";
  QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["BlurbHeadingDesc"] = "blurbHeading_DESC";
  QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["PageHeadingH1Asc"] = "pageHeadingH1_ASC";
  QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["PageHeadingH1Desc"] = "pageHeadingH1_DESC";
  QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["PageNameAsc"] = "pageName_ASC";
  QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["PageNameDesc"] = "pageName_DESC";
  QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder2;
})(QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder || {});
var QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder = /* @__PURE__ */ ((QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder2) => {
  QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder2["BlurbHeadingAsc"] = "blurbHeading_ASC";
  QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder2["BlurbHeadingDesc"] = "blurbHeading_DESC";
  QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder2["PageHeadingH1Asc"] = "pageHeadingH1_ASC";
  QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder2["PageHeadingH1Desc"] = "pageHeadingH1_DESC";
  QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder2["PageNameAsc"] = "pageName_ASC";
  QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder2["PageNameDesc"] = "pageName_DESC";
  QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder2;
})(QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder || {});
var QuestionAndAnswerOrder = /* @__PURE__ */ ((QuestionAndAnswerOrder2) => {
  QuestionAndAnswerOrder2["QuestionAsc"] = "question_ASC";
  QuestionAndAnswerOrder2["QuestionDesc"] = "question_DESC";
  QuestionAndAnswerOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  QuestionAndAnswerOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  QuestionAndAnswerOrder2["SysIdAsc"] = "sys_id_ASC";
  QuestionAndAnswerOrder2["SysIdDesc"] = "sys_id_DESC";
  QuestionAndAnswerOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  QuestionAndAnswerOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  QuestionAndAnswerOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  QuestionAndAnswerOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return QuestionAndAnswerOrder2;
})(QuestionAndAnswerOrder || {});
var RecentSearchesLinkingCollectionsHomepageCollectionOrder = /* @__PURE__ */ ((RecentSearchesLinkingCollectionsHomepageCollectionOrder2) => {
  RecentSearchesLinkingCollectionsHomepageCollectionOrder2["IdAsc"] = "id_ASC";
  RecentSearchesLinkingCollectionsHomepageCollectionOrder2["IdDesc"] = "id_DESC";
  RecentSearchesLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RecentSearchesLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RecentSearchesLinkingCollectionsHomepageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  RecentSearchesLinkingCollectionsHomepageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  RecentSearchesLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RecentSearchesLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RecentSearchesLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RecentSearchesLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RecentSearchesLinkingCollectionsHomepageCollectionOrder2;
})(RecentSearchesLinkingCollectionsHomepageCollectionOrder || {});
var RecentSearchesOrder = /* @__PURE__ */ ((RecentSearchesOrder2) => {
  RecentSearchesOrder2["HeadingAsc"] = "heading_ASC";
  RecentSearchesOrder2["HeadingDesc"] = "heading_DESC";
  RecentSearchesOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  RecentSearchesOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  RecentSearchesOrder2["SysIdAsc"] = "sys_id_ASC";
  RecentSearchesOrder2["SysIdDesc"] = "sys_id_DESC";
  RecentSearchesOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  RecentSearchesOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  RecentSearchesOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  RecentSearchesOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return RecentSearchesOrder2;
})(RecentSearchesOrder || {});
var ReviewCardLinkingCollectionsReviewWidgetCollectionOrder = /* @__PURE__ */ ((ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2) => {
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2["HeadingAsc"] = "heading_ASC";
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2["HeadingDesc"] = "heading_DESC";
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2["SubHeadingAsc"] = "subHeading_ASC";
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2["SubHeadingDesc"] = "subHeading_DESC";
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2["TrustpilotAsc"] = "trustpilot_ASC";
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2["TrustpilotDesc"] = "trustpilot_DESC";
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2["VariantAsc"] = "variant_ASC";
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2["VariantDesc"] = "variant_DESC";
  return ReviewCardLinkingCollectionsReviewWidgetCollectionOrder2;
})(ReviewCardLinkingCollectionsReviewWidgetCollectionOrder || {});
var ReviewCardOrder = /* @__PURE__ */ ((ReviewCardOrder2) => {
  ReviewCardOrder2["HeadingAsc"] = "heading_ASC";
  ReviewCardOrder2["HeadingDesc"] = "heading_DESC";
  ReviewCardOrder2["RatingAsc"] = "rating_ASC";
  ReviewCardOrder2["RatingDesc"] = "rating_DESC";
  ReviewCardOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ReviewCardOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ReviewCardOrder2["SysIdAsc"] = "sys_id_ASC";
  ReviewCardOrder2["SysIdDesc"] = "sys_id_DESC";
  ReviewCardOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ReviewCardOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ReviewCardOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ReviewCardOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ReviewCardOrder2;
})(ReviewCardOrder || {});
var ReviewWidgetOrder = /* @__PURE__ */ ((ReviewWidgetOrder2) => {
  ReviewWidgetOrder2["HeadingAsc"] = "heading_ASC";
  ReviewWidgetOrder2["HeadingDesc"] = "heading_DESC";
  ReviewWidgetOrder2["SubHeadingAsc"] = "subHeading_ASC";
  ReviewWidgetOrder2["SubHeadingDesc"] = "subHeading_DESC";
  ReviewWidgetOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ReviewWidgetOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ReviewWidgetOrder2["SysIdAsc"] = "sys_id_ASC";
  ReviewWidgetOrder2["SysIdDesc"] = "sys_id_DESC";
  ReviewWidgetOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ReviewWidgetOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ReviewWidgetOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ReviewWidgetOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ReviewWidgetOrder2["TrustpilotAsc"] = "trustpilot_ASC";
  ReviewWidgetOrder2["TrustpilotDesc"] = "trustpilot_DESC";
  ReviewWidgetOrder2["VariantAsc"] = "variant_ASC";
  ReviewWidgetOrder2["VariantDesc"] = "variant_DESC";
  return ReviewWidgetOrder2;
})(ReviewWidgetOrder || {});
var ReviewWidgetReviewsCollectionOrder = /* @__PURE__ */ ((ReviewWidgetReviewsCollectionOrder2) => {
  ReviewWidgetReviewsCollectionOrder2["HeadingAsc"] = "heading_ASC";
  ReviewWidgetReviewsCollectionOrder2["HeadingDesc"] = "heading_DESC";
  ReviewWidgetReviewsCollectionOrder2["RatingAsc"] = "rating_ASC";
  ReviewWidgetReviewsCollectionOrder2["RatingDesc"] = "rating_DESC";
  ReviewWidgetReviewsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ReviewWidgetReviewsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ReviewWidgetReviewsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ReviewWidgetReviewsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ReviewWidgetReviewsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ReviewWidgetReviewsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ReviewWidgetReviewsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ReviewWidgetReviewsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ReviewWidgetReviewsCollectionOrder2;
})(ReviewWidgetReviewsCollectionOrder || {});
var SearchLandingPageFallbackContentInterlinksCollectionOrder = /* @__PURE__ */ ((SearchLandingPageFallbackContentInterlinksCollectionOrder2) => {
  SearchLandingPageFallbackContentInterlinksCollectionOrder2["HeadingAsc"] = "heading_ASC";
  SearchLandingPageFallbackContentInterlinksCollectionOrder2["HeadingDesc"] = "heading_DESC";
  SearchLandingPageFallbackContentInterlinksCollectionOrder2["IdAsc"] = "id_ASC";
  SearchLandingPageFallbackContentInterlinksCollectionOrder2["IdDesc"] = "id_DESC";
  SearchLandingPageFallbackContentInterlinksCollectionOrder2["KeyAsc"] = "key_ASC";
  SearchLandingPageFallbackContentInterlinksCollectionOrder2["KeyDesc"] = "key_DESC";
  SearchLandingPageFallbackContentInterlinksCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SearchLandingPageFallbackContentInterlinksCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SearchLandingPageFallbackContentInterlinksCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SearchLandingPageFallbackContentInterlinksCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SearchLandingPageFallbackContentInterlinksCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SearchLandingPageFallbackContentInterlinksCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SearchLandingPageFallbackContentInterlinksCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SearchLandingPageFallbackContentInterlinksCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SearchLandingPageFallbackContentInterlinksCollectionOrder2;
})(SearchLandingPageFallbackContentInterlinksCollectionOrder || {});
var SearchLandingPageFallbackContentOrder = /* @__PURE__ */ ((SearchLandingPageFallbackContentOrder2) => {
  SearchLandingPageFallbackContentOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SearchLandingPageFallbackContentOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SearchLandingPageFallbackContentOrder2["SysIdAsc"] = "sys_id_ASC";
  SearchLandingPageFallbackContentOrder2["SysIdDesc"] = "sys_id_DESC";
  SearchLandingPageFallbackContentOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SearchLandingPageFallbackContentOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SearchLandingPageFallbackContentOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SearchLandingPageFallbackContentOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SearchLandingPageFallbackContentOrder2;
})(SearchLandingPageFallbackContentOrder || {});
var SearchLandingPageFaqsCollectionOrder = /* @__PURE__ */ ((SearchLandingPageFaqsCollectionOrder2) => {
  SearchLandingPageFaqsCollectionOrder2["QuestionAsc"] = "question_ASC";
  SearchLandingPageFaqsCollectionOrder2["QuestionDesc"] = "question_DESC";
  SearchLandingPageFaqsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SearchLandingPageFaqsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SearchLandingPageFaqsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SearchLandingPageFaqsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SearchLandingPageFaqsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SearchLandingPageFaqsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SearchLandingPageFaqsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SearchLandingPageFaqsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SearchLandingPageFaqsCollectionOrder2;
})(SearchLandingPageFaqsCollectionOrder || {});
var SearchLandingPageInterlinksCollectionOrder = /* @__PURE__ */ ((SearchLandingPageInterlinksCollectionOrder2) => {
  SearchLandingPageInterlinksCollectionOrder2["HeadingAsc"] = "heading_ASC";
  SearchLandingPageInterlinksCollectionOrder2["HeadingDesc"] = "heading_DESC";
  SearchLandingPageInterlinksCollectionOrder2["IdAsc"] = "id_ASC";
  SearchLandingPageInterlinksCollectionOrder2["IdDesc"] = "id_DESC";
  SearchLandingPageInterlinksCollectionOrder2["KeyAsc"] = "key_ASC";
  SearchLandingPageInterlinksCollectionOrder2["KeyDesc"] = "key_DESC";
  SearchLandingPageInterlinksCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SearchLandingPageInterlinksCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SearchLandingPageInterlinksCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SearchLandingPageInterlinksCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SearchLandingPageInterlinksCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SearchLandingPageInterlinksCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SearchLandingPageInterlinksCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SearchLandingPageInterlinksCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SearchLandingPageInterlinksCollectionOrder2;
})(SearchLandingPageInterlinksCollectionOrder || {});
var SearchLandingPageOrder = /* @__PURE__ */ ((SearchLandingPageOrder2) => {
  SearchLandingPageOrder2["BlurbHeadingAsc"] = "blurbHeading_ASC";
  SearchLandingPageOrder2["BlurbHeadingDesc"] = "blurbHeading_DESC";
  SearchLandingPageOrder2["PageHeadingH1Asc"] = "pageHeadingH1_ASC";
  SearchLandingPageOrder2["PageHeadingH1Desc"] = "pageHeadingH1_DESC";
  SearchLandingPageOrder2["PageNameAsc"] = "pageName_ASC";
  SearchLandingPageOrder2["PageNameDesc"] = "pageName_DESC";
  SearchLandingPageOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SearchLandingPageOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SearchLandingPageOrder2["SysIdAsc"] = "sys_id_ASC";
  SearchLandingPageOrder2["SysIdDesc"] = "sys_id_DESC";
  SearchLandingPageOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SearchLandingPageOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SearchLandingPageOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SearchLandingPageOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SearchLandingPageOrder2;
})(SearchLandingPageOrder || {});
var SectionLinkingCollectionsHomepageCollectionOrder = /* @__PURE__ */ ((SectionLinkingCollectionsHomepageCollectionOrder2) => {
  SectionLinkingCollectionsHomepageCollectionOrder2["IdAsc"] = "id_ASC";
  SectionLinkingCollectionsHomepageCollectionOrder2["IdDesc"] = "id_DESC";
  SectionLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SectionLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SectionLinkingCollectionsHomepageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SectionLinkingCollectionsHomepageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SectionLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SectionLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SectionLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SectionLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SectionLinkingCollectionsHomepageCollectionOrder2;
})(SectionLinkingCollectionsHomepageCollectionOrder || {});
var SectionOrder = /* @__PURE__ */ ((SectionOrder2) => {
  SectionOrder2["ChipTextAsc"] = "chipText_ASC";
  SectionOrder2["ChipTextDesc"] = "chipText_DESC";
  SectionOrder2["CtaLabelAsc"] = "ctaLabel_ASC";
  SectionOrder2["CtaLabelDesc"] = "ctaLabel_DESC";
  SectionOrder2["CtaLinkAsc"] = "ctaLink_ASC";
  SectionOrder2["CtaLinkDesc"] = "ctaLink_DESC";
  SectionOrder2["EyebrowAsc"] = "eyebrow_ASC";
  SectionOrder2["EyebrowDesc"] = "eyebrow_DESC";
  SectionOrder2["HeadingAsc"] = "heading_ASC";
  SectionOrder2["HeadingDesc"] = "heading_DESC";
  SectionOrder2["IdAsc"] = "id_ASC";
  SectionOrder2["IdDesc"] = "id_DESC";
  SectionOrder2["IsImageOnRightAsc"] = "isImageOnRight_ASC";
  SectionOrder2["IsImageOnRightDesc"] = "isImageOnRight_DESC";
  SectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SectionOrder2;
})(SectionOrder || {});
var SeoComponentLinkingCollectionsBlogPostCollectionOrder = /* @__PURE__ */ ((SeoComponentLinkingCollectionsBlogPostCollectionOrder2) => {
  SeoComponentLinkingCollectionsBlogPostCollectionOrder2["CreatedAtAsc"] = "createdAt_ASC";
  SeoComponentLinkingCollectionsBlogPostCollectionOrder2["CreatedAtDesc"] = "createdAt_DESC";
  SeoComponentLinkingCollectionsBlogPostCollectionOrder2["SlugAsc"] = "slug_ASC";
  SeoComponentLinkingCollectionsBlogPostCollectionOrder2["SlugDesc"] = "slug_DESC";
  SeoComponentLinkingCollectionsBlogPostCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SeoComponentLinkingCollectionsBlogPostCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SeoComponentLinkingCollectionsBlogPostCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SeoComponentLinkingCollectionsBlogPostCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SeoComponentLinkingCollectionsBlogPostCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SeoComponentLinkingCollectionsBlogPostCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SeoComponentLinkingCollectionsBlogPostCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SeoComponentLinkingCollectionsBlogPostCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  SeoComponentLinkingCollectionsBlogPostCollectionOrder2["TitleAsc"] = "title_ASC";
  SeoComponentLinkingCollectionsBlogPostCollectionOrder2["TitleDesc"] = "title_DESC";
  SeoComponentLinkingCollectionsBlogPostCollectionOrder2["UpdatedAtAsc"] = "updatedAt_ASC";
  SeoComponentLinkingCollectionsBlogPostCollectionOrder2["UpdatedAtDesc"] = "updatedAt_DESC";
  return SeoComponentLinkingCollectionsBlogPostCollectionOrder2;
})(SeoComponentLinkingCollectionsBlogPostCollectionOrder || {});
var SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder = /* @__PURE__ */ ((SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder2) => {
  SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["BlurbHeadingAsc"] = "blurbHeading_ASC";
  SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["BlurbHeadingDesc"] = "blurbHeading_DESC";
  SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["PageHeadingH1Asc"] = "pageHeadingH1_ASC";
  SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["PageHeadingH1Desc"] = "pageHeadingH1_DESC";
  SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["PageNameAsc"] = "pageName_ASC";
  SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["PageNameDesc"] = "pageName_DESC";
  SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder2;
})(SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder || {});
var SeoComponentLinkingCollectionsHomepageCollectionOrder = /* @__PURE__ */ ((SeoComponentLinkingCollectionsHomepageCollectionOrder2) => {
  SeoComponentLinkingCollectionsHomepageCollectionOrder2["IdAsc"] = "id_ASC";
  SeoComponentLinkingCollectionsHomepageCollectionOrder2["IdDesc"] = "id_DESC";
  SeoComponentLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SeoComponentLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SeoComponentLinkingCollectionsHomepageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SeoComponentLinkingCollectionsHomepageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SeoComponentLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SeoComponentLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SeoComponentLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SeoComponentLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SeoComponentLinkingCollectionsHomepageCollectionOrder2;
})(SeoComponentLinkingCollectionsHomepageCollectionOrder || {});
var SeoComponentLinkingCollectionsPageCollectionOrder = /* @__PURE__ */ ((SeoComponentLinkingCollectionsPageCollectionOrder2) => {
  SeoComponentLinkingCollectionsPageCollectionOrder2["SlugAsc"] = "slug_ASC";
  SeoComponentLinkingCollectionsPageCollectionOrder2["SlugDesc"] = "slug_DESC";
  SeoComponentLinkingCollectionsPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SeoComponentLinkingCollectionsPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SeoComponentLinkingCollectionsPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SeoComponentLinkingCollectionsPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SeoComponentLinkingCollectionsPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SeoComponentLinkingCollectionsPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SeoComponentLinkingCollectionsPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SeoComponentLinkingCollectionsPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  SeoComponentLinkingCollectionsPageCollectionOrder2["TitleAsc"] = "title_ASC";
  SeoComponentLinkingCollectionsPageCollectionOrder2["TitleDesc"] = "title_DESC";
  return SeoComponentLinkingCollectionsPageCollectionOrder2;
})(SeoComponentLinkingCollectionsPageCollectionOrder || {});
var SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder = /* @__PURE__ */ ((SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder2) => {
  SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder2["BlurbHeadingAsc"] = "blurbHeading_ASC";
  SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder2["BlurbHeadingDesc"] = "blurbHeading_DESC";
  SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder2["PageHeadingH1Asc"] = "pageHeadingH1_ASC";
  SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder2["PageHeadingH1Desc"] = "pageHeadingH1_DESC";
  SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder2["PageNameAsc"] = "pageName_ASC";
  SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder2["PageNameDesc"] = "pageName_DESC";
  SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder2;
})(SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder || {});
var SeoComponentOrder = /* @__PURE__ */ ((SeoComponentOrder2) => {
  SeoComponentOrder2["CanonicalAsc"] = "canonical_ASC";
  SeoComponentOrder2["CanonicalDesc"] = "canonical_DESC";
  SeoComponentOrder2["FollowAsc"] = "follow_ASC";
  SeoComponentOrder2["FollowDesc"] = "follow_DESC";
  SeoComponentOrder2["IndexedAsc"] = "indexed_ASC";
  SeoComponentOrder2["IndexedDesc"] = "indexed_DESC";
  SeoComponentOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  SeoComponentOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  SeoComponentOrder2["SysIdAsc"] = "sys_id_ASC";
  SeoComponentOrder2["SysIdDesc"] = "sys_id_DESC";
  SeoComponentOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  SeoComponentOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  SeoComponentOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  SeoComponentOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  SeoComponentOrder2["TitleAsc"] = "title_ASC";
  SeoComponentOrder2["TitleDesc"] = "title_DESC";
  return SeoComponentOrder2;
})(SeoComponentOrder || {});
var ShopCategoriesCollectionOrder = /* @__PURE__ */ ((ShopCategoriesCollectionOrder2) => {
  ShopCategoriesCollectionOrder2["NameAsc"] = "name_ASC";
  ShopCategoriesCollectionOrder2["NameDesc"] = "name_DESC";
  ShopCategoriesCollectionOrder2["SlugAsc"] = "slug_ASC";
  ShopCategoriesCollectionOrder2["SlugDesc"] = "slug_DESC";
  ShopCategoriesCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ShopCategoriesCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ShopCategoriesCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  ShopCategoriesCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  ShopCategoriesCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ShopCategoriesCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ShopCategoriesCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ShopCategoriesCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return ShopCategoriesCollectionOrder2;
})(ShopCategoriesCollectionOrder || {});
var ShopOrder = /* @__PURE__ */ ((ShopOrder2) => {
  ShopOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  ShopOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  ShopOrder2["SysIdAsc"] = "sys_id_ASC";
  ShopOrder2["SysIdDesc"] = "sys_id_DESC";
  ShopOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  ShopOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  ShopOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  ShopOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  ShopOrder2["VersionAsc"] = "version_ASC";
  ShopOrder2["VersionDesc"] = "version_DESC";
  return ShopOrder2;
})(ShopOrder || {});
var StackLinkingCollectionsHomepageCollectionOrder = /* @__PURE__ */ ((StackLinkingCollectionsHomepageCollectionOrder2) => {
  StackLinkingCollectionsHomepageCollectionOrder2["IdAsc"] = "id_ASC";
  StackLinkingCollectionsHomepageCollectionOrder2["IdDesc"] = "id_DESC";
  StackLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  StackLinkingCollectionsHomepageCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  StackLinkingCollectionsHomepageCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  StackLinkingCollectionsHomepageCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  StackLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  StackLinkingCollectionsHomepageCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  StackLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  StackLinkingCollectionsHomepageCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return StackLinkingCollectionsHomepageCollectionOrder2;
})(StackLinkingCollectionsHomepageCollectionOrder || {});
var StackOrder = /* @__PURE__ */ ((StackOrder2) => {
  StackOrder2["NameAsc"] = "name_ASC";
  StackOrder2["NameDesc"] = "name_DESC";
  StackOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  StackOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  StackOrder2["SysIdAsc"] = "sys_id_ASC";
  StackOrder2["SysIdDesc"] = "sys_id_DESC";
  StackOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  StackOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  StackOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  StackOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return StackOrder2;
})(StackOrder || {});
var TestimonialOrder = /* @__PURE__ */ ((TestimonialOrder2) => {
  TestimonialOrder2["AttributionAsc"] = "attribution_ASC";
  TestimonialOrder2["AttributionDesc"] = "attribution_DESC";
  TestimonialOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TestimonialOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TestimonialOrder2["SysIdAsc"] = "sys_id_ASC";
  TestimonialOrder2["SysIdDesc"] = "sys_id_DESC";
  TestimonialOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TestimonialOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TestimonialOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TestimonialOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TestimonialOrder2;
})(TestimonialOrder || {});
var TradeTraitsOrder = /* @__PURE__ */ ((TradeTraitsOrder2) => {
  TradeTraitsOrder2["FootnoteAsc"] = "footnote_ASC";
  TradeTraitsOrder2["FootnoteDesc"] = "footnote_DESC";
  TradeTraitsOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TradeTraitsOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TradeTraitsOrder2["SysIdAsc"] = "sys_id_ASC";
  TradeTraitsOrder2["SysIdDesc"] = "sys_id_DESC";
  TradeTraitsOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TradeTraitsOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TradeTraitsOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TradeTraitsOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TradeTraitsOrder2;
})(TradeTraitsOrder || {});
var TradeTraitsTraitsCollectionOrder = /* @__PURE__ */ ((TradeTraitsTraitsCollectionOrder2) => {
  TradeTraitsTraitsCollectionOrder2["HeadingAsc"] = "heading_ASC";
  TradeTraitsTraitsCollectionOrder2["HeadingDesc"] = "heading_DESC";
  TradeTraitsTraitsCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  TradeTraitsTraitsCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  TradeTraitsTraitsCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  TradeTraitsTraitsCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  TradeTraitsTraitsCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  TradeTraitsTraitsCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  TradeTraitsTraitsCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  TradeTraitsTraitsCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return TradeTraitsTraitsCollectionOrder2;
})(TradeTraitsTraitsCollectionOrder || {});
var UrlRedirectOrder = /* @__PURE__ */ ((UrlRedirectOrder2) => {
  UrlRedirectOrder2["NoteAsc"] = "note_ASC";
  UrlRedirectOrder2["NoteDesc"] = "note_DESC";
  UrlRedirectOrder2["PathAsc"] = "path_ASC";
  UrlRedirectOrder2["PathDesc"] = "path_DESC";
  UrlRedirectOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  UrlRedirectOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  UrlRedirectOrder2["SysIdAsc"] = "sys_id_ASC";
  UrlRedirectOrder2["SysIdDesc"] = "sys_id_DESC";
  UrlRedirectOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  UrlRedirectOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  UrlRedirectOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  UrlRedirectOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  UrlRedirectOrder2["TypeAsc"] = "type_ASC";
  UrlRedirectOrder2["TypeDesc"] = "type_DESC";
  UrlRedirectOrder2["UrlAsc"] = "url_ASC";
  UrlRedirectOrder2["UrlDesc"] = "url_DESC";
  return UrlRedirectOrder2;
})(UrlRedirectOrder || {});
var VariationContainerOrder = /* @__PURE__ */ ((VariationContainerOrder2) => {
  VariationContainerOrder2["EnvironmentAsc"] = "environment_ASC";
  VariationContainerOrder2["EnvironmentDesc"] = "environment_DESC";
  VariationContainerOrder2["ExperimentIdAsc"] = "experimentId_ASC";
  VariationContainerOrder2["ExperimentIdDesc"] = "experimentId_DESC";
  VariationContainerOrder2["ExperimentKeyAsc"] = "experimentKey_ASC";
  VariationContainerOrder2["ExperimentKeyDesc"] = "experimentKey_DESC";
  VariationContainerOrder2["ExperimentTitleAsc"] = "experimentTitle_ASC";
  VariationContainerOrder2["ExperimentTitleDesc"] = "experimentTitle_DESC";
  VariationContainerOrder2["FlagKeyAsc"] = "flagKey_ASC";
  VariationContainerOrder2["FlagKeyDesc"] = "flagKey_DESC";
  VariationContainerOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  VariationContainerOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  VariationContainerOrder2["SysIdAsc"] = "sys_id_ASC";
  VariationContainerOrder2["SysIdDesc"] = "sys_id_DESC";
  VariationContainerOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  VariationContainerOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  VariationContainerOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  VariationContainerOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  return VariationContainerOrder2;
})(VariationContainerOrder || {});
var WidgetLinkingCollectionsHeroCollectionOrder = /* @__PURE__ */ ((WidgetLinkingCollectionsHeroCollectionOrder2) => {
  WidgetLinkingCollectionsHeroCollectionOrder2["SubtitleAsc"] = "subtitle_ASC";
  WidgetLinkingCollectionsHeroCollectionOrder2["SubtitleDesc"] = "subtitle_DESC";
  WidgetLinkingCollectionsHeroCollectionOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  WidgetLinkingCollectionsHeroCollectionOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  WidgetLinkingCollectionsHeroCollectionOrder2["SysIdAsc"] = "sys_id_ASC";
  WidgetLinkingCollectionsHeroCollectionOrder2["SysIdDesc"] = "sys_id_DESC";
  WidgetLinkingCollectionsHeroCollectionOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  WidgetLinkingCollectionsHeroCollectionOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  WidgetLinkingCollectionsHeroCollectionOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  WidgetLinkingCollectionsHeroCollectionOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  WidgetLinkingCollectionsHeroCollectionOrder2["ThemeAsc"] = "theme_ASC";
  WidgetLinkingCollectionsHeroCollectionOrder2["ThemeDesc"] = "theme_DESC";
  WidgetLinkingCollectionsHeroCollectionOrder2["TitleAsc"] = "title_ASC";
  WidgetLinkingCollectionsHeroCollectionOrder2["TitleDesc"] = "title_DESC";
  return WidgetLinkingCollectionsHeroCollectionOrder2;
})(WidgetLinkingCollectionsHeroCollectionOrder || {});
var WidgetOrder = /* @__PURE__ */ ((WidgetOrder2) => {
  WidgetOrder2["SysFirstPublishedAtAsc"] = "sys_firstPublishedAt_ASC";
  WidgetOrder2["SysFirstPublishedAtDesc"] = "sys_firstPublishedAt_DESC";
  WidgetOrder2["SysIdAsc"] = "sys_id_ASC";
  WidgetOrder2["SysIdDesc"] = "sys_id_DESC";
  WidgetOrder2["SysPublishedAtAsc"] = "sys_publishedAt_ASC";
  WidgetOrder2["SysPublishedAtDesc"] = "sys_publishedAt_DESC";
  WidgetOrder2["SysPublishedVersionAsc"] = "sys_publishedVersion_ASC";
  WidgetOrder2["SysPublishedVersionDesc"] = "sys_publishedVersion_DESC";
  WidgetOrder2["Value1Asc"] = "value1_ASC";
  WidgetOrder2["Value1Desc"] = "value1_DESC";
  WidgetOrder2["Value2Asc"] = "value2_ASC";
  WidgetOrder2["Value2Desc"] = "value2_DESC";
  WidgetOrder2["Value3Asc"] = "value3_ASC";
  WidgetOrder2["Value3Desc"] = "value3_DESC";
  WidgetOrder2["Value4Asc"] = "value4_ASC";
  WidgetOrder2["Value4Desc"] = "value4_DESC";
  WidgetOrder2["WidgetNameAsc"] = "widgetName_ASC";
  WidgetOrder2["WidgetNameDesc"] = "widgetName_DESC";
  return WidgetOrder2;
})(WidgetOrder || {});
var BannerItemFragmentDoc = gql`
    fragment BannerItem on Banner {
  internalName
  enabled
  desktopOnly
  icon
  heading
  content {
    json
  }
  key
  dismissable
  showAgain
}
    `;
var HomepageBannersListFragmentDoc = gql`
    fragment HomepageBannersList on HomepageBannersCollection {
  items {
    ...BannerItem
  }
}
    `;
var ListItemItemFragmentDoc = gql`
    fragment ListItemItem on ListItem {
  __typename
  sys {
    id
  }
  heading
  icon {
    url
  }
  content {
    json
  }
}
    `;
var ReviewItemFragmentDoc = gql`
    fragment ReviewItem on ReviewCard {
  __typename
  sys {
    id
  }
  heading
  rating
  review
}
    `;
var CategoryLandingPageContentLinksItemFragmentDoc = gql`
    fragment CategoryLandingPageContentLinksItem on CategoryLandingPageContentLinks {
  entries {
    block {
      __typename
      sys {
        id
      }
      ... on MediaBanner {
        heading
        logosCollection {
          items {
            url
            title
          }
        }
      }
      ... on BenefitsSolutions {
        heading
        subHeading
        image {
          url
        }
        listCollection {
          items {
            ...ListItemItem
          }
        }
        background
        variant
      }
      ... on HowItWorks {
        heading
        subHeading
        stepsCollection {
          items {
            ...ListItemItem
          }
        }
        payIconsCollection {
          items {
            url
            title
          }
        }
        payBanner {
          json
        }
      }
      ... on ReviewWidget {
        heading
        subHeading
        reviewsCollection {
          items {
            ...ReviewItem
          }
        }
        variant
      }
      ... on CategoryLandingPageHero {
        heading
        image {
          url
        }
        listCollection {
          items {
            ...ListItemItem
          }
        }
        bannerHeading
        bannerSubHeading
        bannerIcon {
          url
        }
        bannerRating
      }
      ... on JumboCta {
        heading
        subHeading
        ctaText
      }
      ... on LandingPageStatistics {
        figuresCollection {
          items {
            ...ListItemItem
          }
        }
      }
      ... on TradeTraits {
        summary {
          json
        }
        traitsCollection {
          items {
            ...ListItemItem
          }
        }
        footnote
      }
      ... on Testimonial {
        quote
        attribution
        image {
          url
        }
      }
    }
  }
}
    `;
var CardItemFragmentDoc = gql`
    fragment CardItem on Card {
  __typename
  sys {
    id
  }
  heading
  description {
    json
  }
  ctaLabel
  image {
    url
  }
  link
}
    `;
var CardListItemFragmentDoc = gql`
    fragment CardListItem on CardList {
  id
  sys {
    id
  }
  __typename
  heading
  cardsCollection {
    items {
      ...CardItem
    }
  }
}
    `;
var SectionItemFragmentDoc = gql`
    fragment SectionItem on Section {
  __typename
  sys {
    id
  }
  heading
  description {
    json
  }
  ctaLabel
  ctaLink
  image {
    url
  }
  eyebrow
  chipText
  isImageOnRight
}
    `;
var EntryItemFragmentDoc = gql`
    fragment EntryItem on Entry {
  sys {
    id
  }
  ... on CardList {
    ...CardListItem
  }
  ... on Section {
    ...SectionItem
  }
}
    `;
var HeroItemFragmentDoc = gql`
    fragment HeroItem on Hero {
  title
  subtitle
  theme
  backgroundImage {
    url
  }
  adornment {
    url
  }
  primaryCta {
    value1
    value2
    value3
  }
}
    `;
var PopularSearchItemCategoryFragmentDoc = gql`
    fragment PopularSearchItemCategory on Category {
  label
  categoryId
  iconSvg
}
    `;
var PopularSearchesCategoriesCollectionItemsFragmentDoc = gql`
    fragment PopularSearchesCategoriesCollectionItems on PopularSearchesCategoriesCollection {
  items {
    ...PopularSearchItemCategory
  }
}
    `;
var PopularSearchesItemFragmentDoc = gql`
    fragment PopularSearchesItem on PopularSearches {
  __typename
  id
  heading
  categoriesCollection {
    ...PopularSearchesCategoriesCollectionItems
  }
}
    `;
var StackItemsCollectionListItemsFragmentDoc = gql`
    fragment StackItemsCollectionListItems on StackItemsCollection {
  items {
    ...ListItemItem
  }
}
    `;
var StackItemsCollectionFragmentDoc = gql`
    fragment StackItemsCollection on Stack {
  __typename
  itemsCollection {
    ...StackItemsCollectionListItems
  }
}
    `;
var HomepageContentCollectionItemFragmentDoc = gql`
    fragment HomepageContentCollectionItem on HomepageContentItem {
  __typename
  ... on PopularSearches {
    ...PopularSearchesItem
  }
  ...StackItemsCollection
  ... on CardList {
    ...CardListItem
  }
}
    `;
var LinksGroupItemFragmentDoc = gql`
    fragment LinksGroupItem on LinksGroup {
  id
  key
  heading
  links {
    json
  }
}
    `;
var LocationItemFragmentDoc = gql`
    fragment LocationItem on ContentTypeLocation {
  location
  slug
}
    `;
var AccordionItemFragmentDoc = gql`
    fragment AccordionItem on AccordionItem {
  title
  content {
    json
  }
}
    `;
var CallOutBoxItemFragmentDoc = gql`
    fragment CallOutBoxItem on CallOutBox {
  title
  message {
    json
  }
}
    `;
var PageContentLinksItemFragmentDoc = gql`
    fragment PageContentLinksItem on PageContentLinks {
  entries {
    block {
      __typename
      sys {
        id
      }
      ... on Widget {
        widgetName
        value1
        value2
        value3
        value4
      }
      ... on Accordion {
        accordionItemsCollection {
          items {
            ...AccordionItem
          }
        }
      }
      ... on CallOutBox {
        ...CallOutBoxItem
      }
    }
  }
  assets {
    block {
      __typename
      sys {
        id
      }
      ... on Asset {
        title
        description
        url
        width
        height
      }
    }
  }
}
    `;
var SeoItemFragmentDoc = gql`
    fragment SeoItem on SeoComponent {
  title
  keywords
  description
  ogImage {
    url
    title
    width
    height
  }
  canonical
  indexed
  follow
  additionalSchema
}
    `;
var CardsListDocument = gql`
    query cardsList($id: String!, $preview: Boolean) {
  cardList(id: $id, preview: $preview) {
    ...CardListItem
  }
}
    ${CardListItemFragmentDoc}
${CardItemFragmentDoc}`;
var CategoriesDocument = gql`
    query categories($skip: Int, $limit: Int) {
  categoryCollection(skip: $skip, limit: $limit) {
    items {
      categoryId
      label
      iconSvg
    }
  }
}
    `;
var CategoryLandingPageDocument = gql`
    query categoryLandingPage($categorySlug: String!) {
  categoryLandingPageCollection(
    limit: 1
    where: {category: {slug: $categorySlug}}
  ) {
    items {
      category {
        categoryId
        slug
        label
      }
      ctaText
      content {
        json
        links {
          ...CategoryLandingPageContentLinksItem
        }
      }
      footer {
        json
      }
    }
  }
}
    ${CategoryLandingPageContentLinksItemFragmentDoc}
${ListItemItemFragmentDoc}
${ReviewItemFragmentDoc}`;
var CategoryDocument = gql`
    query category($id: Int!) {
  categoryCollection(where: {categoryId: $id}) {
    items {
      categoryId
      label
      iconSvg
    }
  }
}
    `;
var DefaultInterlinksDocument = gql`
    query defaultInterlinks($skip: Int = 0, $limit: Int = 1) {
  defaultInterlinksCollection(skip: $skip, limit: $limit) {
    items {
      interlinksCollection {
        items {
          ...LinksGroupItem
        }
      }
    }
  }
}
    ${LinksGroupItemFragmentDoc}`;
var DefaultSearchLandingPageDocument = gql`
    query defaultSearchLandingPage($categoryId: Int, $indexed: Boolean, $skip: Int = 0, $limit: Int = 1) {
  defaultSearchLandingPageCollection(
    where: {category: {categoryId: $categoryId}, seoMetadata: {indexed: $indexed}}
    skip: $skip
    limit: $limit
  ) {
    items {
      pageName
      pageHeadingH1
      category {
        categoryId
        label
        slug
      }
      seoMetadata {
        ...SeoItem
      }
      blurbHeading
      blurb
      faqsCollection {
        items {
          question
          answer
        }
      }
      interlinksCollection {
        items {
          ...LinksGroupItem
        }
      }
    }
  }
}
    ${SeoItemFragmentDoc}
${LinksGroupItemFragmentDoc}`;
var DefaultSearchLandingPagesDocument = gql`
    query defaultSearchLandingPages($categoryId: Int, $indexed: Boolean, $skip: Int = 0, $limit: Int = 100) {
  defaultSearchLandingPageCollection(
    where: {category: {categoryId: $categoryId}, seoMetadata: {indexed: $indexed}}
    skip: $skip
    limit: $limit
  ) {
    items {
      category {
        categoryId
        label
        slug
      }
      seoMetadata {
        ...SeoItem
      }
    }
  }
}
    ${SeoItemFragmentDoc}`;
var EntriesDocument = gql`
    query entries($ids: [String!]!, $preview: Boolean) {
  entryCollection(where: {sys: {id_in: $ids}}, preview: $preview) {
    items {
      ...EntryItem
    }
  }
}
    ${EntryItemFragmentDoc}
${CardListItemFragmentDoc}
${CardItemFragmentDoc}
${SectionItemFragmentDoc}`;
var HeroDocument = gql`
    query hero($id: String!, $preview: Boolean) {
  hero(id: $id, preview: $preview) {
    ...HeroItem
  }
}
    ${HeroItemFragmentDoc}`;
var HomepageSeoDocument = gql`
    query homepageSeo($id: String!, $preview: Boolean) {
  homepage(id: $id, preview: $preview) {
    seo {
      ...SeoItem
    }
  }
}
    ${SeoItemFragmentDoc}`;
var HomepageDocument = gql`
    query homepage($id: String!, $preview: Boolean) {
  homepage(id: $id, preview: $preview) {
    sys {
      id
    }
    bannersCollection(limit: 1) {
      ...HomepageBannersList
    }
    hero {
      ...HeroItem
    }
    contentCollection(limit: 10) {
      items {
        ...HomepageContentCollectionItem
      }
    }
    seoInterlinkingCollection {
      items {
        ...LinksGroupItem
      }
    }
  }
}
    ${HomepageBannersListFragmentDoc}
${BannerItemFragmentDoc}
${HeroItemFragmentDoc}
${HomepageContentCollectionItemFragmentDoc}
${PopularSearchesItemFragmentDoc}
${PopularSearchesCategoriesCollectionItemsFragmentDoc}
${PopularSearchItemCategoryFragmentDoc}
${StackItemsCollectionFragmentDoc}
${StackItemsCollectionListItemsFragmentDoc}
${ListItemItemFragmentDoc}
${CardListItemFragmentDoc}
${CardItemFragmentDoc}
${LinksGroupItemFragmentDoc}`;
var LinksGroupsDocument = gql`
    query linksGroups($idContains: String, $limit: Int!, $preview: Boolean) {
  linksGroupCollection(
    limit: $limit
    where: {id_contains: $idContains}
    preview: $preview
  ) {
    items {
      ...LinksGroupItem
    }
  }
}
    ${LinksGroupItemFragmentDoc}`;
var LocationDocument = gql`
    query location($skip: Int, $limit: Int) {
  locationCollection: contentTypeLocationCollection(skip: $skip, limit: $limit) {
    items {
      ...LocationItem
    }
  }
}
    ${LocationItemFragmentDoc}`;
var PageSeoDocument = gql`
    query pageSeo($slug: String!, $preview: Boolean) {
  pageCollection(where: {slug: $slug}, preview: $preview, limit: 1) {
    items {
      seo {
        ...SeoItem
      }
    }
  }
}
    ${SeoItemFragmentDoc}`;
var PageDocument = gql`
    query page($slug: String!, $preview: Boolean) {
  pageCollection(where: {slug: $slug}, preview: $preview, limit: 1) {
    items {
      title
      slug
      content {
        json
        links {
          ...PageContentLinksItem
        }
      }
    }
  }
}
    ${PageContentLinksItemFragmentDoc}
${AccordionItemFragmentDoc}
${CallOutBoxItemFragmentDoc}`;
var PagesSlugsDocument = gql`
    query pagesSlugs($preview: Boolean, $limit: Int, $skip: Int) {
  pageCollection(preview: $preview, limit: $limit, skip: $skip) {
    items {
      slug
    }
    total
  }
}
    `;
var SearchLandingPageDocument = gql`
    query searchLandingPage($categoryId: Int, $locationSlug: String, $indexed: Boolean, $skip: Int = 0, $limit: Int = 1) {
  searchLandingPageCollection(
    where: {category: {categoryId: $categoryId}, location: {slug: $locationSlug}, seoMetadata: {indexed: $indexed}}
    skip: $skip
    limit: $limit
  ) {
    items {
      pageName
      pageHeadingH1
      category {
        categoryId
        label
        slug
      }
      location {
        ...LocationItem
      }
      seoMetadata {
        ...SeoItem
      }
      blurbHeading
      blurb
      faqsCollection {
        items {
          question
          answer
        }
      }
      interlinksCollection {
        items {
          ...LinksGroupItem
        }
      }
    }
  }
}
    ${LocationItemFragmentDoc}
${SeoItemFragmentDoc}
${LinksGroupItemFragmentDoc}`;
var SearchLandingPagesDocument = gql`
    query searchLandingPages($categoryId: Int, $locationSlug: String, $indexed: Boolean, $skip: Int = 0, $limit: Int = 100) {
  searchLandingPageCollection(
    where: {category: {categoryId: $categoryId}, location: {slug: $locationSlug}, seoMetadata: {indexed: $indexed}}
    skip: $skip
    limit: $limit
  ) {
    items {
      category {
        categoryId
        label
        slug
      }
      location {
        ...LocationItem
      }
      seoMetadata {
        ...SeoItem
      }
    }
  }
}
    ${LocationItemFragmentDoc}
${SeoItemFragmentDoc}`;
var defaultWrapper = (action, _operationName, _operationType, _variables) => action();
function getSdk(client, withWrapper = defaultWrapper) {
  return {
    cardsList(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CardsListDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "cardsList", "query", variables);
    },
    categories(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CategoriesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "categories", "query", variables);
    },
    categoryLandingPage(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CategoryLandingPageDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "categoryLandingPage", "query", variables);
    },
    category(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(CategoryDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "category", "query", variables);
    },
    defaultInterlinks(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(DefaultInterlinksDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "defaultInterlinks", "query", variables);
    },
    defaultSearchLandingPage(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(DefaultSearchLandingPageDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "defaultSearchLandingPage", "query", variables);
    },
    defaultSearchLandingPages(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(DefaultSearchLandingPagesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "defaultSearchLandingPages", "query", variables);
    },
    entries(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(EntriesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "entries", "query", variables);
    },
    hero(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(HeroDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "hero", "query", variables);
    },
    homepageSeo(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(HomepageSeoDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "homepageSeo", "query", variables);
    },
    homepage(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(HomepageDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "homepage", "query", variables);
    },
    linksGroups(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(LinksGroupsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "linksGroups", "query", variables);
    },
    location(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(LocationDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "location", "query", variables);
    },
    pageSeo(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(PageSeoDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "pageSeo", "query", variables);
    },
    page(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(PageDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "page", "query", variables);
    },
    pagesSlugs(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(PagesSlugsDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "pagesSlugs", "query", variables);
    },
    searchLandingPage(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(SearchLandingPageDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "searchLandingPage", "query", variables);
    },
    searchLandingPages(variables, requestHeaders) {
      return withWrapper((wrappedRequestHeaders) => client.request(SearchLandingPagesDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }), "searchLandingPages", "query", variables);
    }
  };
}
export {
  AccordionAccordionItemsCollectionOrder,
  AccordionItemFragmentDoc,
  AccordionItemLinkingCollectionsAccordionCollectionOrder,
  AccordionItemOrder,
  AccordionOrder,
  AssetOrder,
  BannerItemFragmentDoc,
  BannerLinkingCollectionsHomepageCollectionOrder,
  BannerOrder,
  BenefitsSolutionsListCollectionOrder,
  BenefitsSolutionsOrder,
  BlogPostLinkingCollectionsBlogPostCollectionOrder,
  BlogPostOrder,
  BlogPostRelatedPostsCollectionOrder,
  BlogTableCellReferenceOrder,
  CallOutBoxItemFragmentDoc,
  CallOutBoxOrder,
  CardItemFragmentDoc,
  CardLinkingCollectionsCardListCollectionOrder,
  CardListCardsCollectionOrder,
  CardListItemFragmentDoc,
  CardListLinkingCollectionsHomepageCollectionOrder,
  CardListOrder,
  CardOrder,
  CardsListDocument,
  CategoriesDocument,
  CategoryClosestAlternativesCollectionOrder,
  CategoryDocument,
  CategoryHeroLinkingCollectionsProductCategoryCollectionOrder,
  CategoryHeroOrder,
  CategoryLandingPageContentLinksItemFragmentDoc,
  CategoryLandingPageDocument,
  CategoryLandingPageHeroListCollectionOrder,
  CategoryLandingPageHeroOrder,
  CategoryLandingPageOrder,
  CategoryLinkingCollectionsBlogPostCollectionOrder,
  CategoryLinkingCollectionsCategoryCollectionOrder,
  CategoryLinkingCollectionsCategoryLandingPageCollectionOrder,
  CategoryLinkingCollectionsDefaultSearchLandingPageCollectionOrder,
  CategoryLinkingCollectionsPopularSearchesCollectionOrder,
  CategoryLinkingCollectionsSearchLandingPageCollectionOrder,
  CategoryOrder,
  CategorySubCategoriesCollectionOrder,
  ContentTypeLocationLinkingCollectionsSearchLandingPageCollectionOrder,
  ContentTypeLocationOrder,
  DefaultInterlinksDocument,
  DefaultInterlinksInterlinksCollectionOrder,
  DefaultInterlinksOrder,
  DefaultSearchLandingPageDocument,
  DefaultSearchLandingPageFaqsCollectionOrder,
  DefaultSearchLandingPageInterlinksCollectionOrder,
  DefaultSearchLandingPageOrder,
  DefaultSearchLandingPagesDocument,
  EntriesDocument,
  EntryItemFragmentDoc,
  EntryOrder,
  HeroDocument,
  HeroImageOrder,
  HeroItemFragmentDoc,
  HeroLinkingCollectionsHomepageCollectionOrder,
  HeroLinkingCollectionsShopCollectionOrder,
  HeroOrder,
  HomepageBannersCollectionOrder,
  HomepageBannersListFragmentDoc,
  HomepageContentCollectionItemFragmentDoc,
  HomepageDocument,
  HomepageOrder,
  HomepageSeoDocument,
  HomepageSeoInterlinkingCollectionOrder,
  HowItWorksOrder,
  HowItWorksStepsCollectionOrder,
  IconOrder,
  ImageFormat,
  ImageResizeFocus,
  ImageResizeStrategy,
  JumboCtaOrder,
  LandingPageStatisticsFiguresCollectionOrder,
  LandingPageStatisticsOrder,
  LeadEnrichmentFormBuilderOrder,
  LeadEnrichmentFormConsumerImagesLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder,
  LeadEnrichmentFormConsumerImagesOrder,
  LeadEnrichmentFormJobDescriptionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder,
  LeadEnrichmentFormJobDescriptionOrder,
  LeadEnrichmentFormJobPreferredStartsLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder,
  LeadEnrichmentFormJobPreferredStartsOrder,
  LeadEnrichmentFormMultiSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder,
  LeadEnrichmentFormMultiSelectOrder,
  LeadEnrichmentFormMultiVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder,
  LeadEnrichmentFormMultiVisualSelectionOrder,
  LeadEnrichmentFormOwnershipStatusLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder,
  LeadEnrichmentFormOwnershipStatusOrder,
  LeadEnrichmentFormQuestionSingleSelectLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder,
  LeadEnrichmentFormQuestionSingleSelectOrder,
  LeadEnrichmentFormSingleVisualSelectionLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder,
  LeadEnrichmentFormSingleVisualSelectionOrder,
  LeadEnrichmentFormTextFieldLinkingCollectionsLeadEnrichmentFormBuilderCollectionOrder,
  LeadEnrichmentFormTextFieldOrder,
  LinksGroupItemFragmentDoc,
  LinksGroupLinkingCollectionsDefaultInterlinksCollectionOrder,
  LinksGroupLinkingCollectionsDefaultSearchLandingPageCollectionOrder,
  LinksGroupLinkingCollectionsHomepageCollectionOrder,
  LinksGroupLinkingCollectionsSearchLandingPageCollectionOrder,
  LinksGroupLinkingCollectionsSearchLandingPageFallbackContentCollectionOrder,
  LinksGroupOrder,
  LinksGroupsDocument,
  ListItemItemFragmentDoc,
  ListItemLinkingCollectionsBenefitsSolutionsCollectionOrder,
  ListItemLinkingCollectionsCategoryLandingPageHeroCollectionOrder,
  ListItemLinkingCollectionsHowItWorksCollectionOrder,
  ListItemLinkingCollectionsLandingPageStatisticsCollectionOrder,
  ListItemLinkingCollectionsTradeTraitsCollectionOrder,
  ListItemOrder,
  LocationDocument,
  LocationItemFragmentDoc,
  MediaBannerOrder,
  PageContentLinksItemFragmentDoc,
  PageDocument,
  PageOrder,
  PageSeoDocument,
  PagesSlugsDocument,
  PopularSearchItemCategoryFragmentDoc,
  PopularSearchesCategoriesCollectionItemsFragmentDoc,
  PopularSearchesCategoriesCollectionOrder,
  PopularSearchesItemFragmentDoc,
  PopularSearchesLinkingCollectionsHomepageCollectionOrder,
  PopularSearchesOrder,
  ProductCategoryContentCollectionOrder,
  ProductCategoryContentLinkingCollectionsProductCategoryCollectionOrder,
  ProductCategoryContentOrder,
  ProductCategoryImageLinkingCollectionsProductCategoryContentCollectionOrder,
  ProductCategoryImageOrder,
  ProductCategoryLinkingCollectionsShopCollectionOrder,
  ProductCategoryOrder,
  ProductCategoryTextBlockLinkingCollectionsProductCategoryContentCollectionOrder,
  ProductCategoryTextBlockOrder,
  ProductPartnerLinkingCollectionsCategoryHeroCollectionOrder,
  ProductPartnerOrder,
  QuestionAndAnswerLinkingCollectionsDefaultSearchLandingPageCollectionOrder,
  QuestionAndAnswerLinkingCollectionsSearchLandingPageCollectionOrder,
  QuestionAndAnswerOrder,
  RecentSearchesLinkingCollectionsHomepageCollectionOrder,
  RecentSearchesOrder,
  ReviewCardLinkingCollectionsReviewWidgetCollectionOrder,
  ReviewCardOrder,
  ReviewItemFragmentDoc,
  ReviewWidgetOrder,
  ReviewWidgetReviewsCollectionOrder,
  SearchLandingPageDocument,
  SearchLandingPageFallbackContentInterlinksCollectionOrder,
  SearchLandingPageFallbackContentOrder,
  SearchLandingPageFaqsCollectionOrder,
  SearchLandingPageInterlinksCollectionOrder,
  SearchLandingPageOrder,
  SearchLandingPagesDocument,
  SectionItemFragmentDoc,
  SectionLinkingCollectionsHomepageCollectionOrder,
  SectionOrder,
  SeoComponentLinkingCollectionsBlogPostCollectionOrder,
  SeoComponentLinkingCollectionsDefaultSearchLandingPageCollectionOrder,
  SeoComponentLinkingCollectionsHomepageCollectionOrder,
  SeoComponentLinkingCollectionsPageCollectionOrder,
  SeoComponentLinkingCollectionsSearchLandingPageCollectionOrder,
  SeoComponentOrder,
  SeoItemFragmentDoc,
  ShopCategoriesCollectionOrder,
  ShopOrder,
  StackItemsCollectionFragmentDoc,
  StackItemsCollectionListItemsFragmentDoc,
  StackLinkingCollectionsHomepageCollectionOrder,
  StackOrder,
  TestimonialOrder,
  TradeTraitsOrder,
  TradeTraitsTraitsCollectionOrder,
  UrlRedirectOrder,
  VariationContainerOrder,
  WidgetLinkingCollectionsHeroCollectionOrder,
  WidgetOrder,
  getSdk
};
